// import React, { useRef, useState, useEffect } from "react";
// import "./testscheduling.css";
// import DropDown from "./Dropwon-testscheduling";
// import DropDown2 from "./Dropdwon-Shuffle";
// import DropDown3 from "./Drodpwon-Catch";
// import InputComponent from "./Input-testscheduling";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
// import DateComponent from "./DateComponent";
// import CalenderImg from "../../../Assets/Images/CommanImages/CalenderImg.png";
// import TextEditor from "../../Landing/components/TextEditor";
// import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
// import MultiSelectSearchDropdown2 from "./Mulit-Dropdwon";
// import MultiSelectSearchDropdown3 from "./MulitSelectDropDown3";
// import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
// import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import Colors from "../../../Constants/Colors";
// import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
// import { useNavigate } from "react-router-dom";
// import { PUT, GET, POST } from "../../../Api/HttpsMethods";
// import EndPoints from "../../../Api/EndPoints";
// import { useSearchParams } from "react-router-dom";
// import RejectModal from "../../../Components/RejectModal/RejectModal";
// import TestPrintModal from '../../../Components/Modals/PreviewforTestSchedule';
// import PrintQuestionPaperModal from "../../../Components/Modals/PrintQuestionPaperModal";

// const TestSchedulingClone = ({
//   dataClient,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const navigate = useNavigate();
//   const [scopeSpecificData, setScopeSpecificData] = useState([]);
//   const [scopeSelection, setScopeSelection] = useState([]);
//   const [scopeRefDisplay, setScopeRefDisplay] = useState("");
//   const [scopeRefNAMES, setscopeRefNAMES] = useState([]);
//   const [initialScopeRefIds, setInitialScopeRefIds] = useState([]);
//   const [showPrintModal, setShowPrintModal] = useState(false);
//   const [selectedPrintSet, setSelectedPrintSet] = useState('A');

//   // ─── SERVER CURRENT TIME STATE ───────────────────────────────────────────────
//   const [serverCurrentTime, setServerCurrentTime] = useState(null);

//   useEffect(() => {
//     if (dataClient) {
//       const userName =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);

//   const [showPreviewModal, setShowPreviewModal] = useState(false);

//   const userName =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
//     sessionStorage.getItem("user_name") ||
//     "";

//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
//     sessionStorage.getItem("clientBranchId") ||
//     null;

//   const clientId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
//     sessionStorage.getItem("clientId") ||
//     null;

//   const [selectedCoordinatorOption, setSelectedCoordinatorOption] = useState(null);

//   const [searchParams] = useSearchParams();
//   const testScheduleId = searchParams.get("IDs");

//   const [markingSchemeFromAPI, setMarkingSchemeFromAPI] = useState([]);

//   const [isReadOnly, setIsReadOnly] = useState(true);
//   const [isEditMode, setIsEditMode] = useState(false);

//   const handleEditSaveClick = () => {
//     if (!isReadOnly) {
//       // When saving, don't flip isReadOnly here —
//       // handleSave will flip it only on success
//       handleSave();
//       return;
//     }
//     // Entering edit mode
//     setIsReadOnly(false);
//   };

//   const [testSeriesPrefix, setTestSeriesPrefix] = useState("");
//   const [testNameUserPart, setTestNameUserPart] = useState("");
//   const [testDescription, setTestDescription] = useState("");

//   const [scopeRefID, setScopeRefID] = useState("");

//   const [showCancelModal, setShowCancelModal] = useState(false);

//   const [quesPaperScopeID, setquesPaperScopeID] = useState("");
//   const [shuffleSubjects, setShuffleSubjects] = useState(0);
//   const [shuffleQuestions, setShuffleQuestions] = useState(1);
//   const [shuffleOptions, setShuffleOptions] = useState(0);
//   const [markingSchemeList, setMarkingSchemeList] = useState([]);
//   const [markingSchemeCount, setMarkingSchemeCount] = useState(1);
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [paperSubjects, setPaperSubjects] = useState([]);

//   const [ChangedTestCoordinator, setChangedTestCoordinator] = useState("");
//   const [showMarkingScheme, setShowMarkingScheme] = useState(false);
//   const [testSeriesSubjects, setTestSeriesSubjects] = useState("");
//   const [testSeriesDescription, setTestSeriesDescription] = useState("");
//   const [numberOfSets, setNumberOfSets] = useState(1);
//   const [subjects, setSubjects] = useState("");
//   const [selectedTestSeries, setSelectedTestSeries] = useState(null);
//   const [testSeries, setTestSeries] = useState([]);
//   const [testStartDate, setTestStartDate] = useState(null);
//   const [testEndDate, setTestEndDate] = useState(null);
//   const [courses, setCourses] = useState([]);
//   const [scopes, setScopes] = useState([]);
//   const [courseOpted, setCourseOpted] = useState("");
//   const [CordinatorName, setCordinatorName] = useState("Shashi,Parser");
//   const [testMode, setTestMode] = useState(1);
//   const normalizedTestMode = testMode !== null ? Number(testMode) : "";
//   const [testSearchKey, setTestSearchKey] = useState("");
//   const [sessionOptions, setSessionOptions] = useState([]);
//   const [classOptions, setClassOptions] = useState([]);
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [allScopeData, setAllScopeData] = useState([]);
//   const [testTemplates, setTestTemplates] = useState([]);

//   const accessToken = localStorage.getItem("other");
//   const [time, setTime] = useState("");
//   const [timeMinutes, setTimeMinutes] = useState("");
//   const [batchData, setBatchData] = useState([]);
//   const [selectedBatch, setSelectedBatch] = useState([]);
//   const [branchData, setBranchData] = useState([]);
//   const [zoneData, setZoneData] = useState([]);
//   const [selectedCities, setSelectedCities] = useState([]);
//   const [cityData, setCityData] = useState([]);
//   const [selectedStates, setSelectedStates] = useState([]);
//   const [stateData, setStateData] = useState([]);
//   const [selectScope, setSelectedScope] = useState(null);
//   const [selectedBranch, setSelectedBranch] = useState([]);
//   const [selectedZone, setSelectedZone] = useState([]);
//   const [selectedRegion, setSelectedRegion] = useState([]);
//   const [testName, setTestName] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [testNames, setTestNames] = useState([]);
//   const [facultyList, setFacultyList] = useState([]);

//   const [testCoordinator, setTestCoordinator] = useState(null);
//   const [quesPaperList, setQuesPaperList] = useState([]);
//   const [selectedQuesPaper, setSelectedQuesPaper] = useState(null);
//   const [quesPaperDescription, setQuesPaperDescription] = useState("");
//   const [quesPaperCreatedBy, setQuesPaperCreatedBy] = useState("");
//   const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState(
//     Array(markingSchemeCount).fill(null)
//   );
//   const [open, setOpen] = useState(false);

//   const scopeId =
//     selectScope && typeof selectScope === "object"
//       ? selectScope.id
//       : selectScope;

//   const isScopeGroup = Number(scopeId) === 9;

//   const [bodyVisible, setBodyVisible] = useState(true);
//   const [schedulingVisible, setSchedulingVisible] = useState(true);
//   const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);
//   const isTestSeriesNone =
//     selectedTestSeries === 0 || selectedTestSeries === null;

//   const toggleBodyVisible = () => {
//     setBodyVisible(!bodyVisible);
//   };
//   const toggleSchedulingVisible = () => {
//     setSchedulingVisible(!schedulingVisible);
//   };
//   const toggleMarkingSchemeVisible = () => {
//     setMarkingSchemeVisible(!markingSchemeVisible);
//   };

//   const handleInputChange = (e) => {
//     const minutes = e.target.value;
//     const hours = (minutes / 60).toFixed(2);
//     setTime(hours);
//     setTimeMinutes(minutes);
//   };

//   const [CurrentTimeFromServer, setCurrentTimeFromServer] = useState(null);

//   // Student group states
//   const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
//   const [allStudentGroups, setAllStudentGroups] = useState([]);
//   const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
//   const [initialStudentGroupIds, setInitialStudentGroupIds] = useState([]);
//   const [studentGroupNames, setStudentGroupNames] = useState("");
//   const [studentGroupsLoading, setStudentGroupsLoading] = useState(false);
//   const [studentGroupsError, setStudentGroupsError] = useState(null);
//   const [isTestWindowEnded, setIsTestWindowEnded] = useState(false);

//   // ── Refs that hold the LAST SAVED start/end dates ─────────────────────────
//   // Used as reference points for validation so that unsaved changes don't
//   // affect the comparison baseline. Initialized when data loads from API.
//   const savedStartDateRef = useRef(null);
//   const savedEndDateRef   = useRef(null);

//   // ─── FETCH SERVER CURRENT TIME ────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchServerTime = async () => {
//       try {
//         const response = await GET.withToken(EndPoints.GetCurrentDateTime, {
//           setMessageBox,
//           setIsMessageBoxVisible,
//           setActiveImg,
//           ErrorImg,
//         });

//         if (response?.status === 200 && response?.data) {
//           const { current_date, current_time } = response.data;
//           // Combine into a single datetime string: "2026-05-19T14:30:00"
//           const combined = `${current_date}T${current_time}`;
//           setServerCurrentTime(combined);
//         }
//       } catch (error) {
//         console.error("Error fetching server time:", error);
//         // Fallback to browser time if server time fetch fails
//         setServerCurrentTime(new Date().toISOString());
//       }
//     };

//     fetchServerTime();
//   }, []);

//   // ─── HELPER: GET CURRENT DATETIME + 15 MIN BUFFER (from server) ───────────────
//   const getCurrentDateTime = () => {
//     const base = serverCurrentTime
//       ? new Date(serverCurrentTime)
//       : new Date(); // fallback to browser time if server time not yet loaded
//     base.setMinutes(base.getMinutes() + 15); // +15 minutes buffer
//     const year = base.getFullYear();
//     const month = String(base.getMonth() + 1).padStart(2, "0");
//     const day = String(base.getDate()).padStart(2, "0");
//     const hours = String(base.getHours()).padStart(2, "0");
//     const minutes = String(base.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${minutes}`;
//   };

//   // Add this useEffect to populate description from test series
//   useEffect(() => {
//     if (!selectedTestSeries || !testSeries.length) return;

//     const selectedSeries = testSeries.find(
//       (ts) => ts.ts_id === Number(selectedTestSeries)
//     );

//     if (selectedSeries?.ts_desc) {
//       setTestSeriesDescription(selectedSeries.ts_desc);
//     }
//   }, [selectedTestSeries, testSeries]);

//   // Fetch test schedule details
//   useEffect(() => {
//     const fetchTestScheduleDetails = async () => {
//       if (!testScheduleId) return;

//       const url = `${EndPoints.GetTestSchedulebyIdv1}?test_schedule_id=${testScheduleId}`;

//       const response = await GET.withToken(url, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       const data = response?.data;
//       if (data) {
//         setSelectedTestSeries(data.ts_id);
//         setScopeRefID(data.scope_ref_id || "");
//         setQuesPaperDescription(data.ques_paper_desc || "");
//         setQuesPaperCreatedBy(data.ques_paper_created_by || "");
//         setTestNameUserPart(data.test_name || "");
//         setTestDescription(data.test_desc || "");
//         setCurrentTimeFromServer(data.current_time || "");

//         // Check if test window has ended
//         if (data.current_time && data.test_window_end) {
//           const currentTime = new Date(data.current_time);
//           const testEndTime = new Date(data.test_window_end);
//           setIsTestWindowEnded(currentTime > testEndTime);
//         }

//         if (data.ques_paper_id && data.ques_paper_name) {
//           setSelectedQuesPaper({
//             id: data.ques_paper_id,
//             label: data.ques_paper_name
//           });
//         }

//         if (data.scope_ref_id_list && Array.isArray(data.scope_ref_id_list)) {
//           setInitialScopeRefIds(data.scope_ref_id_list);
//           setScopeSelection(data.scope_ref_id_list);
//         }

//         if (data.student_group_id_list && Array.isArray(data.student_group_id_list)) {
//           const groupIds = data.student_group_id_list.map(g =>
//             typeof g === 'object' ? g.student_group_id : g
//           );
//           setInitialStudentGroupIds(groupIds);
//           setSelectedStudentGroup(groupIds);

//           const groupNames = data.student_group_id_list
//             .map(g => typeof g === 'object' ? g.student_group_name : '')
//             .filter(Boolean)
//             .join(", ");
//           setStudentGroupNames(groupNames);
//         }

//         if (data.ques_paper_scope_id) {
//           setquesPaperScopeID(data.ques_paper_scope_id);
//         }

//         if (data.subject_id_list && Array.isArray(data.subject_id_list)) {
//           const subjectNames = data.subject_id_list.map(
//             (subject) => subject.subject_name
//           );
//           setTestSeriesSubjects(subjectNames.join(", "));
//         }

//         const formatDateForInput = (isoString) => {
//           if (!isoString) return "";
//           if (isoString.length === 19 && isoString.includes("T")) {
//             return isoString.slice(0, 16);
//           }
//           const date = new Date(isoString);
//           const year = date.getFullYear();
//           const month = String(date.getMonth() + 1).padStart(2, "0");
//           const day = String(date.getDate()).padStart(2, "0");
//           const hours = String(date.getHours()).padStart(2, "0");
//           const minutes = String(date.getMinutes()).padStart(2, "0");

//           return `${year}-${month}-${day}T${hours}:${minutes}`;
//         };

//         const formattedStart = formatDateForInput(data.test_window_start);
//         const formattedEnd   = formatDateForInput(data.test_window_end);
//         setTestStartDate(formattedStart);
//         setTestEndDate(formattedEnd);
//         // Store last saved values — used as validation baseline
//         savedStartDateRef.current = formattedStart;
//         savedEndDateRef.current   = formattedEnd;
//         setTimeMinutes(data.duration || "");
//         setTime((data.duration / 60).toFixed(2) || "");
//         setTestCoordinator(data.test_coordinator_name || null);
//         setChangedTestCoordinator(data.test_coordnator_emp_id || null);
//         setTestMode(data.test_mode || 1);
//         setNumberOfSets(data.no_of_sets || 1);
//         setInstructionsHtml(data.instructions_html || "");
//         setShuffleQuestions(data.shuffle_questions ? 1 : 0);
//         setShuffleSubjects(data.shuffle_subjects ? 1 : 0);
//         setShuffleOptions(data.shuffle_options ? 1 : 0);

//         setMarkingSchemeFromAPI(data.marking_scheme || []);
//       }
//     };

//     fetchTestScheduleDetails();
//   }, [testScheduleId]);

//   // Fetch student groups
//   useEffect(() => {
//     const fetchStudentGroups = async () => {
//       if (!clientBranchId) return;

//       try {
//         setStudentGroupsLoading(true);
//         setStudentGroupsError(null);

//         const url = `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`;

//         const resp = await fetch(url, {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });

//         if (resp.status === 401 || resp.status === 403) {
//           setStudentGroupsError("Not authenticated. Please login.");
//           setStudentGroupsOptions([]);
//           setAllStudentGroups([]);
//           return;
//         }

//         const json = await resp.json();

//         if (json && (json.status === "200" || json.status === 200) && Array.isArray(json.data)) {
//           const options = json.data.map((group) => ({
//             id: group.student_group_id,
//             label: group.student_group_name,
//             session_id: group.session_id || "",
//             course_id: group.course_id || "",
//           }));
//           setStudentGroupsOptions(options);
//           setAllStudentGroups(options);
//         } else {
//           setStudentGroupsOptions([]);
//           setAllStudentGroups([]);
//         }
//       } catch (err) {
//         console.error("Error fetching student groups:", err);
//         setStudentGroupsError(err.message || "Error");
//         setStudentGroupsOptions([]);
//         setAllStudentGroups([]);
//       } finally {
//         setStudentGroupsLoading(false);
//       }
//     };
//     fetchStudentGroups();
//   }, [clientBranchId, accessToken]);

//   // Update student group names when options load
//   useEffect(() => {
//     if (allStudentGroups.length > 0 && initialStudentGroupIds.length > 0 && !studentGroupNames) {
//       const matchingGroups = allStudentGroups.filter((g) =>
//         initialStudentGroupIds.includes(g.id)
//       );
//       if (matchingGroups.length > 0) {
//         setStudentGroupNames(matchingGroups.map((g) => g.label).join(", "));
//       }
//     }
//   }, [allStudentGroups, initialStudentGroupIds, studentGroupNames]);

//   // Client-side filtering for student groups
//   const searchStudentGroups = (searchKey) => {
//     const selectedCourseId = courseOpted
//       ? typeof courseOpted === "object"
//         ? courseOpted.id
//         : courseOpted
//       : null;

//     let filtered = allStudentGroups;
//     if (selectedCourseId) {
//       filtered = filtered.filter((g) => g.course_id === selectedCourseId);
//     }

//     if (searchKey && searchKey.trim() !== "") {
//       filtered = filtered.filter((g) =>
//         g.label.toLowerCase().includes(searchKey.toLowerCase())
//       );
//     }

//     setStudentGroupsOptions(filtered);
//   };

//   const getFilteredStudentGroups = () => {
//     if (!courseOpted) return studentGroupsOptions;

//     const selectedCourseId = typeof courseOpted === "object" ? courseOpted.id : courseOpted;
//     return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
//   };

//   useEffect(() => {
//     if (isScopeGroup && !isReadOnly) {
//       setScopeSelection([]);
//     }
//   }, [isScopeGroup, isReadOnly]);

//   useEffect(() => {
//     if (
//       scopeSpecificData.length > 0 &&
//       initialScopeRefIds.length > 0
//     ) {
//       const matchingOptions = scopeSpecificData.filter((option) =>
//         initialScopeRefIds.includes(option.id)
//       );

//       if (matchingOptions.length > 0) {
//         const displayNames = matchingOptions.map((opt) => opt.label).join(", ");
//         setscopeRefNAMES(displayNames);
//       }
//     }
//   }, [scopeSpecificData, initialScopeRefIds]);

//   useEffect(() => {
//     if (
//       !selectedTestSeries ||
//       !courses.length ||
//       !scopes.length ||
//       !sessionOptions.length ||
//       !classOptions.length
//     )
//       return;

//     const selectedSeries = testSeries.find(
//       (ts) => ts.ts_id === Number(selectedTestSeries)
//     );

//     if (!selectedSeries) return;

//     const course = courses.find(
//       (c) => c.course_id === selectedSeries.course_id
//     );
//     if (course) {
//       setCourseOpted({ id: course.course_id, label: course.course_name });
//     }

//     const scope = scopes.find(
//       (s) => s.ques_paper_scope_id === selectedSeries.scope_id
//     );
//     if (scope) {
//       setSelectedScope({
//         id: scope.ques_paper_scope_id,
//         label: scope.ques_paper_scope_desc,
//       });
//     }

//     const session = sessionOptions.find(
//       (s) => s.id === selectedSeries.session_name
//     );
//     if (session) {
//       setSelectedSession(session.id);
//     }

//     if (Array.isArray(selectedSeries.class_id_list)) {
//       const matchedClasses = selectedSeries.class_id_list
//         .map((id) => {
//           const cls = classOptions.find((c) => c.id === id);
//           return cls ? cls.id : null;
//         })
//         .filter(Boolean);

//       if (matchedClasses.length) {
//         setSelectedClass(matchedClasses);
//       }
//     }
//   }, [
//     selectedTestSeries,
//     testSeries,
//     courses,
//     scopes,
//     sessionOptions,
//     classOptions,
//   ]);

//   useEffect(() => {
//     if (testScheduleId) return;

//     const interval = setInterval(() => {
//       if (!testSeries.length) return;

//       const selectedSeries = testSeries.find(
//         (ts) => ts.ts_id === Number(selectedTestSeries)
//       );

//       if (selectedSeries?.ts_desc) {
//         setTestDescription(selectedSeries.ts_desc);
//         clearInterval(interval);
//       }
//     }, 200);

//     return () => clearInterval(interval);
//   }, [selectedTestSeries, testSeries, testScheduleId]);

//   useEffect(() => {
//     if (!selectedTestSeries || !testSeries.length) return;

//     const selectedSeries = testSeries.find(
//       (ts) => ts.ts_id === Number(selectedTestSeries)
//     );

//     if (!selectedSeries?.scope_ref_ids?.length) return;

//     const refIds = selectedSeries.scope_ref_ids.map((r) => r.id);

//     const getLabel = (list, id) => {
//       const found = list.find((item) => item.id === id);
//       return found?.label || found?.batch_name || found?.name || "";
//     };

//     let scopeLabels = [];

//     switch (selectedSeries.scope_id) {
//       case 1:
//         scopeLabels = refIds.map((id) => getLabel(batchData, id));
//         break;
//       case 2:
//         scopeLabels = refIds.map((id) => getLabel(branchData, id));
//         break;
//       case 3:
//         scopeLabels = refIds.map((id) => getLabel(zoneData, id));
//         break;
//       case 4:
//         scopeLabels = refIds.map((id) => getLabel(cityData, id));
//         break;
//       case 5:
//         scopeLabels = refIds.map((id) => getLabel(stateData, id));
//         break;
//       case 6:
//         scopeLabels = refIds.map((id) => getLabel(selectedRegion, id));
//         break;
//       default:
//         break;
//     }

//     const cleanLabels = scopeLabels.filter(Boolean);
//   }, [
//     selectedTestSeries,
//     testSeries,
//     batchData,
//     branchData,
//     zoneData,
//     cityData,
//     stateData,
//     selectedRegion,
//   ]);

//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-courses/`
//         );
//         const data = await response.json();
//         setCourses(data);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching courses: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };

//     fetchCourses();
//   }, []);

//   useEffect(() => {
//     const fetchScopes = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-list-of-scopes`,
//           {
//             headers: { accept: "application/json" },
//           }
//         );
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json();
//         const activeScopes = data.filter((scope) => scope.status === 1);
//         setScopes(activeScopes);
//       } catch (error) {
//         console.error("Error fetching :", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching Scopes: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };
//     fetchScopes();
//   }, []);

//   useEffect(() => {
//     const fetchQuestionPaperList = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const courseId = courseOpted
//           ? typeof courseOpted === "object"
//             ? courseOpted.id
//             : courseOpted
//           : "";
//         let classQuery = "";
//         if (Array.isArray(selectedClass) && selectedClass.length > 0) {
//           classQuery = selectedClass.map((id) => `&class_id=${id}`).join("");
//         }
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-ques-paper-list/?branch_id=${clientBranchId}&course_id=${courseId}${classQuery}`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const result = await response.json();
//         if (result.status === 200) {
//           setQuesPaperList(result.data);
//         }
//       } catch (error) {
//         console.error("Error fetching question paper list:", error);
//       }
//     };
//     fetchQuestionPaperList();
//   }, [clientBranchId, courseOpted, selectedClass, userName]);

//   useEffect(() => {
//     if (selectScope !== null) {
//       fetchScopeDetails();
//     }
//   }, [selectScope, courseOpted, selectedSession, selectedClass]);

//   const fetchScopeDetails = async () => {
//     const scopeId =
//       typeof selectScope === "object" ? selectScope.id : selectScope;

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-scopes-details-all`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = await response.json();

//       if (data.status === 200) {
//         let apiData = data.data;

//         if (scopeId === 1 && courseOpted) {
//           const selectedCourseId =
//             typeof courseOpted === "object" ? courseOpted.id : courseOpted;
//           apiData = apiData.filter(
//             (item) => item.course_id === selectedCourseId
//           );
//         }

//         if (selectedSession) {
//           apiData = apiData.filter(
//             (item) => item.session_name === selectedSession
//           );
//         }

//         let scopeOptions = [];

//         switch (scopeId) {
//           case 1:
//             scopeOptions = apiData.map((item) => ({
//               id: item.batch_id,
//               label: item.batch_name,
//             }));
//             break;

//           case 2:
//             scopeOptions = apiData.map((item) => ({
//               id: item.branch_id,
//               label: item.branch_name,
//             }));
//             break;

//           case 3:
//             scopeOptions = apiData.map((item) => ({
//               id: item.city_zone_id,
//               label: item.zone_name,
//             }));
//             break;

//           case 4:
//             scopeOptions = apiData.map((item) => ({
//               id: item.city_id,
//               label: item.city_name,
//             }));
//             break;

//           case 5:
//             scopeOptions = apiData.map((item) => ({
//               id: item.state_id,
//               label: item.state_name,
//             }));
//             break;

//           case 7:
//           case 8:
//             scopeOptions = [
//               {
//                 id: 1,
//                 label: "All India",
//               },
//             ];
//             break;

//           case 9:
//             scopeOptions = [];
//             break;

//           default:
//             scopeOptions = [];
//         }

//         scopeOptions = Array.from(
//           new Map(scopeOptions.map((opt) => [opt.id, opt])).values()
//         );

//         setScopeSpecificData(scopeOptions);
//       }
//     } catch (error) {
//       console.error("Error fetching scope details:", error);
//       setScopeSpecificData([]);
//     }
//   };

//   const getScopeLabel = (scopeId) => {
//     const id = typeof scopeId === "object" ? scopeId.id : scopeId;
//     switch (id) {
//       case 1:
//         return "Batch";
//       case 2:
//         return "Branch";
//       case 3:
//         return "Zone";
//       case 4:
//         return "City";
//       case 5:
//         return "State";
//       case 7:
//         return "All India (Internal)";
//       case 8:
//         return "All India (Open)";
//       case 9:
//         return "Group";
//       default:
//         return "Scope";
//     }
//   };

//   useEffect(() => {
//     const fetchTestSeries = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-test-series-list-by-branch/?client_branch_id=${clientBranchId}`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const result = await response.json();
//         if (result.status === 200) {
//           setTestSeries(result.data);

//           if (selectedTestSeries) {
//             const matched = result.data.find(
//               (ts) => ts.ts_id === Number(selectedTestSeries)
//             );
//             if (matched) {
//               handleTestSeriesSelect(matched.ts_id);
//             }
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching test series:", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching test series: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };

//     if (clientBranchId && testScheduleId) {
//       fetchTestSeries();
//     }
//   }, [clientBranchId, testScheduleId]);

//   useEffect(() => {
//     const fetchMarkingSchemes = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`,
//           { headers: { accept: "application/json" } }
//         );
//         const result = await response.json();
//         if (result.status_code === 200 || result.status === "success") {
//           setMarkingSchemeList(result.data);
//         }
//       } catch (error) {
//         console.error("Error fetching marking schemes:", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching marking schemes: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };

//     fetchMarkingSchemes();
//   }, []);

//   useEffect(() => {
//     if (!paperSubjects?.length || !markingSchemeList?.length) return;

//     const stored = sessionStorage.getItem("testScheduleDetails");
//     if (!stored) return;

//     const scheduleData = JSON.parse(stored);
//     const msFromSchedule = scheduleData.marking_scheme || [];
//     if (!Array.isArray(msFromSchedule)) return;

//     const newSelections = {};

//     paperSubjects.forEach((subject) => {
//       const match = msFromSchedule.find(
//         (ms) => ms.subject_id === subject.subject_id
//       );
//       if (!match) return;

//       ["a", "b", "c", "d"].forEach((char, idx) => {
//         const msId = match[`ms_id_sec_${char}`];
//         if (msId) {
//           const rowKey = `${subject.subject_name}-${idx + 1}`;
//           newSelections[rowKey] = msId;
//         }
//       });
//     });

//     setSelectedMarkingSchemes(newSelections);
//   }, [paperSubjects, markingSchemeList]);

//   useEffect(() => {
//     const fetchSessionsAndClasses = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-scopes-details-all/`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         if (data.status === 200) {
//           const apiData = data.data;
//           const sessions = Array.from(
//             new Set(apiData.map((item) => item.session_name))
//           ).map((name) => ({ label: name, id: name }));

//           const classes = Array.from(
//             new Set(apiData.map((item) => item.class_id))
//           ).map((id) => {
//             const found = apiData.find((item) => item.class_id === id);
//             return { label: found ? found.class_name : id, id: id };
//           });

//           classes.sort((a, b) => {
//             const aNum = parseInt(a.label.replace(/\D/g, ""), 10);
//             const bNum = parseInt(b.label.replace(/\D/g, ""), 10);
//             if (!isNaN(aNum) && !isNaN(bNum)) {
//               return aNum - bNum;
//             }
//             return a.label.localeCompare(b.label, undefined, { numeric: true });
//           });

//           setSessionOptions(sessions);
//           setClassOptions(classes);
//         }
//       } catch (error) {
//         console.error("Error fetching session/class data:", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching session/class data: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };

//     fetchSessionsAndClasses();
//   }, []);

//   const searchFaculty = async (searchKey) => {
//     if (searchKey.length < 3) {
//       return;
//     }

//     try {
//       const token = localStorage.getItem("other");
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-faculty-list/?search_key=${searchKey}`,
//         {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const data = await response.json();
//       if (data) {
//         setFacultyList(data);
//       }
//     } catch (error) {
//       console.error("Error searching faculty:", error);
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Error searching faculty: {error.message}</span>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//       }
//     }
//   };

//   const handleQuestionPaperDetails = (details) => {
//     setSelectedQuesPaper({
//       id: details.ques_paper_id,
//       label: details.ques_paper_name,
//     });
//   };

//   const QUESTIONPaperName = selectedQuesPaper?.label || "";

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;

//     const fetchTestTemplates = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-test-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const data = await response.json();
//         setTestTemplates(data);
//       } catch (error) {
//         console.error("Error fetching test templates:", error);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>Error fetching test templates: {error.message}</span>
//               </div>
//             </div>
//           );
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };
//     fetchTestTemplates();
//   }, [userName, clientBranchId]);

//   useEffect(() => {
//     setSelectedMarkingSchemes(Array(markingSchemeCount).fill(null));
//   }, [markingSchemeCount]);

//   const handleTestSeriesSelect = (selectedId) => {
//     setSelectedTestSeries(selectedId);

//     if (selectedId === 0) {
//       setTestSeriesDescription("");
//       setCourseOpted("");
//       setSelectedScope(null);
//       setTestSeriesPrefix("");
//       setSelectedClass(null);
//       setTestSeriesDescription("");
//       setTime("");
//       setTimeMinutes("");
//       setFormData((prev) => ({
//         ...prev,
//         scope_ref_id: [],
//       }));
//       return;
//     }

//     const selectedSeries = testSeries.find((ts) => ts.ts_id === selectedId);

//     if (selectedSeries) {
//       setTestSeriesDescription(selectedSeries.ts_desc || "");
//       setCourseOpted({
//         id: selectedSeries.course_id,
//         label: selectedSeries.course_name,
//       });
//       setSelectedScope({
//         id: selectedSeries.scope_id,
//         label: selectedSeries.scope_name,
//       });

//       setTestSeriesPrefix("");

//       if (selectedSeries.duration_mins) {
//         setTimeMinutes(selectedSeries.duration_mins);
//         setTime((selectedSeries.duration_mins / 60).toFixed(2));
//       } else {
//         setTime("");
//         setTimeMinutes("");
//       }

//       if (
//         selectedSeries.class_id_list &&
//         Array.isArray(selectedSeries.class_id_list)
//       ) {
//         const parsedClasses = selectedSeries.class_id_list.map((id) => {
//           const match = classOptions.find((cls) => cls.id === id);
//           return match || { label: `Class ${id}`, id };
//         });
//         setSelectedClass(parsedClasses.map((cls) => cls.id));
//       }

//       const scopeRefIds = selectedSeries.scope_ref_ids || [];
//       setFormData((prev) => ({
//         ...prev,
//         scope_ref_id: scopeRefIds,
//       }));

//       if (
//         selectedSeries.scope_ref_ids &&
//         Array.isArray(selectedSeries.scope_ref_ids)
//       ) {
//         const scopeNames = selectedSeries.scope_ref_ids
//           .map((item) => item.name)
//           .join(", ");
//         setScopeRefDisplay(scopeNames);
//       }

//       const scopeId = selectedSeries.scope_id;
//       setTimeout(() => {
//         switch (scopeId) {
//           case 1:
//             setSelectedBatch(scopeRefIds);
//             break;
//           case 2:
//             setSelectedBranch(scopeRefIds);
//             break;
//           case 3:
//             setSelectedZone(scopeRefIds);
//             break;
//           case 4:
//             setSelectedCities(scopeRefIds);
//             break;
//           case 5:
//             setSelectedStates(scopeRefIds);
//             break;
//           case 6:
//             setSelectedRegion(scopeRefIds);
//             break;
//           default:
//             break;
//         }
//       }, 500);

//       const scheduleData = selectedSeries;
//       const msFromSchedule = selectedSeries.marking_scheme || [];

//       if (paperSubjects?.length && Array.isArray(msFromSchedule)) {
//         const newSelections = {};

//         paperSubjects.forEach((subject) => {
//           const match = msFromSchedule.find(
//             (ms) => ms.subject_id === subject.subject_id
//           );
//           if (!match) return;

//           subject.sections.forEach((section, idx) => {
//             const char = String.fromCharCode(97 + idx);
//             const msId = match[`ms_id_sec_${char}`];
//             if (msId) {
//               const rowKey = `${subject.subject_name}-${section.section_no}`;
//               newSelections[rowKey] = msId;
//             }
//           });
//         });

//         setSelectedMarkingSchemes((prev) => ({ ...prev, ...newSelections }));
//       }
//     }
//   };

//   const isCancelled = searchParams.get("isCancelled") === "true";

//   const handleSave = async () => {
//     // ── Validate start date ───────────────────────────────────────────────────
//     // Only enforce 15-min-from-now if the start date was changed from saved value
//     const startWasEdited = testStartDate !== savedStartDateRef.current;
//     if (startWasEdited) {
//       const minAllowed = getCurrentDateTime(); // server time + 15 min
//       if (testStartDate && testStartDate < minAllowed) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 Test window start must be at least 15 minutes from current time.
//                 Please correct the start time before saving.
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }
//       const savedStart = savedStartDateRef.current;
//       if (savedStart && testStartDate < savedStart) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 Test window start can only be moved to a later time than the last saved value.
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }
//     }

//     // ── Validate end date ─────────────────────────────────────────────────────
//     const endWasEdited = testEndDate !== savedEndDateRef.current;
//     if (endWasEdited) {
//       const savedEnd = savedEndDateRef.current;
//       if (savedEnd && testEndDate < savedEnd) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 Test window end can only be extended beyond the last saved value, not reduced.
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }
//     }

//     // ── End must be after start ───────────────────────────────────────────────
//     if (testStartDate && testEndDate && testEndDate <= testStartDate) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Test window end must be after the test window start.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     // ── End must accommodate full duration ────────────────────────────────────
//     if (testStartDate && testEndDate && timeMinutes) {
//       const start = new Date(testStartDate);
//       const end   = new Date(testEndDate);
//       const minutesDiff     = (end - start) / (1000 * 60);
//       const requiredMinutes = parseInt(timeMinutes, 10);
//       if (minutesDiff < requiredMinutes) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 Test window duration must be at least {requiredMinutes} minutes (
//                 {(requiredMinutes / 60).toFixed(2)} hours). Please adjust your test window.
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }
//     }

//     const scopeSelectionFilled = Array.isArray(scopeSelection) ? scopeSelection.length > 0 : !!scopeSelection;
//     const studentGroupFilled = Array.isArray(selectedStudentGroup) ? selectedStudentGroup.length > 0 : !!selectedStudentGroup;

//     if (isScopeGroup) {
//       if (!studentGroupFilled) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Please select at least one Student Group when Scope is set to "Group".</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }
//     } else {
//       if (!scopeSelectionFilled && !studentGroupFilled) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Please select at least one Scope Reference OR a Student Group. Both cannot be empty.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         return;
//       }
//     }

//     const token = localStorage.getItem("other");

//     const payload = {
//       ts_id: selectedTestSeries?.ts_id || selectedTestSeries || 1,
//       ques_paper_scope_id: quesPaperScopeID,
//       ques_paper_id: selectedQuesPaper?.id,
//       test_name: testNameUserPart,
//       test_desc: testDescription,
//       test_window_start: testStartDate,
//       test_window_end: testEndDate,
//       duration_mins: Number(timeMinutes),
//       no_of_sets: numberOfSets,
//       test_mode: testMode,
//       test_coordnator_emp_id: ChangedTestCoordinator,
//       client_id: Number(clientId),
//       client_branch_id: Number(clientBranchId),
//       created_by: userName,
//       status: 1,
//       username: userName,
//       instructions_html: instructionsHtml,
//       scope_ref_id_list: isScopeGroup ? [] : scopeSelection,
//       student_group_id_list: Array.isArray(selectedStudentGroup)
//         ? selectedStudentGroup
//         : (selectedStudentGroup ? [selectedStudentGroup] : []),
//       subjects: markingSchemeFromAPI.map((subject) => {
//         const sectionKeys = ["a", "b", "c", "d"];
//         const marking_scheme = {};

//         sectionKeys.forEach((char, idx) => {
//           const key = `${subject.subject_name}-${idx + 1}`;
//           const userSelected = selectedMarkingSchemes?.[key];
//           const apiValue = subject[`ms_id_sec_${char}`];

//           const finalValue = userSelected ?? apiValue ?? 0;

//           if (finalValue !== 0) {
//             marking_scheme[`ms_id_sec_${char}`] = finalValue;
//           }
//         });

//         return {
//           subject_id: subject.subject_id,
//           subject_name: subject.subject_name,
//           marking_scheme: [marking_scheme],
//         };
//       }),
//     };

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/update-test-schedule-v1/?test_schedule_id=${testScheduleId}`,
//         {
//           method: "PUT",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const result = await response.json();
//       if (result.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {result?.message || "Test schedule Updated successfully"}
//                 <strong> ID: {result.data}</strong>
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         // Update saved refs to reflect new saved state
//         savedStartDateRef.current = testStartDate;
//         savedEndDateRef.current   = testEndDate;
//         // Lock the form back to read-only only on successful save
//         setIsReadOnly(true);

//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {result?.message || "Test schedule Could not Update"}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//       }
//     } catch (error) {
//       console.error("Save error details:", error);

//       const errorMessage =
//         error.response?.data?.message ||
//         error.message ||
//         "Unexpected error occurred";

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error saving test schedule: {errorMessage}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const handleGenerateCode = async () => {
//     const url = `${EndPoints.PostGenerateTestCode}?test_schedule_id=${testScheduleId}&user_name=${userName}`;
//     const result = await POST.withToken(
//       url,
//       {},
//       { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//     );

//     if (!result) return;

//     if (result.status === 200) {
//       const { test_schedule_code } = result.data;

//       try {
//         await navigator.clipboard.writeText(test_schedule_code);
//       } catch (err) {
//         console.warn("Clipboard copy failed:", err);
//       }

//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               {result.message}
//               and Copied to Clipboard .{" "}
//               <strong> Code {test_schedule_code}</strong>
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(SuccessImg);
//     } else {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Error: {result.message}</span>
//             <span>Status: {result.status}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//     }

//     setIsMessageBoxVisible(true);
//   };

//   const handleCancelTestSchedule = async (comment) => {
//     const payload = {
//       username: userName,
//       test_schedule_id: Number(testScheduleId),
//       comment: comment,
//     };

//     try {
//       const response = await PUT.withToken(
//         `${FULL_API_BASE_URL}/cancel-test-schedule/`,
//         payload,
//         { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//       );

//       if (response?.status === 200) {
//         setShowCancelModal(false);

//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Test schedule cancelled successfully.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         // Update saved refs to reflect new saved state
//         savedStartDateRef.current = testStartDate;
//         savedEndDateRef.current   = testEndDate;
//         // Lock the form back to read-only only on successful save
//         setIsReadOnly(true);

//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       } else {
//         setShowCancelModal(false);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 {response?.message || "Test schedule cancelled successfully"}
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(SuccessImg);
//         setIsMessageBoxVisible(true);
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           navigate(-1);
//         }, 1500);
//       }
//     } catch (err) {
//       console.error("Cancellation error:", err);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <img src={ErrorImg} alt="Error" />
//           <span>Unexpected error: {err.message}</span>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//     }
//   };

//   const canChangeTestMode = () => {
//     if (!CurrentTimeFromServer || !testStartDate) return false;

//     const serverTime = new Date(CurrentTimeFromServer);
//     const startTime = new Date(testStartDate);
//     const oneHourBeforeStart = new Date(startTime.getTime() - 60 * 60 * 1000);

//     return serverTime <= oneHourBeforeStart;
//   };

//   const isChangingToOffline = (newMode) => {
//     const currentMode = testMode;
//     return (currentMode === 1 || currentMode === 2) && newMode === 3;
//   };

//   const handleTestModeChange = (newMode) => {
//     if (isChangingToOffline(newMode)) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Cannot change from Online mode to Offline mode.</span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     if (!canChangeTestMode()) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               Test Mode can only be changed at least 1 hour before the test
//               start time.
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     setTestMode(newMode);
//   };

//   const isOfflineMode = () => testMode === 3;

//   const canChangeInstructions = () => {
//     if (!CurrentTimeFromServer || !testStartDate) return true;

//     const serverTime = new Date(CurrentTimeFromServer);
//     const startTime = new Date(testStartDate);

//     return serverTime < startTime;
//   };

//   const showOfflineWarning = (action) => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             Warning: {action} in offline mode may require manual coordination
//             with test centers.
//           </span>
//         </div>
//       </div>
//     );
//     setActiveImg(ErrorImg);
//     setIsMessageBoxVisible(true);
//   };

//   const showInstructionsRestriction = () => {
//     console.log("Instructions cannot be changed after the test start time.");
//   };

//   const handleInstructionsChange = (newValue) => {
//     if (!canChangeInstructions()) {
//       showInstructionsRestriction();
//       return;
//     }

//     if (isOfflineMode()) {
//       showOfflineWarning("Changing test instructions");
//     }

//     setInstructionsHtml(newValue);
//   };

//   const updateAllSectionsOfSameType = (sectionIndex, newValue) => {
//     if (!markingSchemeFromAPI.length) return;

//     const updatedSelections = { ...selectedMarkingSchemes };

//     markingSchemeFromAPI.forEach((subjectData) => {
//       const subjectName = subjectData.subject_name;
//       const key = `${subjectName}-${sectionIndex + 1}`;
//       updatedSelections[key] = newValue;
//     });

//     setSelectedMarkingSchemes(updatedSelections);
//   };

//   // ─── UPDATED: getMinEndDateTime uses server time ───────────────────────────
//   const getMinEndDateTime = (startDateTime) => {
//     if (!startDateTime) return getCurrentDateTime();

//     const startDate = new Date(startDateTime);

//     const durationMinutes =
//       timeMinutes && parseInt(timeMinutes, 10) > 0
//         ? parseInt(timeMinutes, 10)
//         : 60;
//     const minEndDate = new Date(
//       startDate.getTime() + durationMinutes * 60 * 1000
//     );

//     const year = minEndDate.getFullYear();
//     const month = String(minEndDate.getMonth() + 1).padStart(2, "0");
//     const day = String(minEndDate.getDate()).padStart(2, "0");
//     const hours = String(minEndDate.getHours()).padStart(2, "0");
//     const minutes = String(minEndDate.getMinutes()).padStart(2, "0");

//     return `${year}-${month}-${day}T${hours}:${minutes}`;
//   };

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">
//         <div
//           style={{
//             position: "sticky",
//             top: 0,
//             backgroundColor: "white",
//             zIndex: 10,
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: "20px",
//               width: "98%",
//             }}
//           >
//             <div
//               style={{
//                 fontSize: "30px",
//                 color: `${Colors.color1}`,
//                 fontWeight: "400",
//               }}
//             >
//               Test Scheduling
//             </div>
//             <div>
//               <div className="row-cs-uni">
//                 {testMode === 1 && (
//                   <button
//                     className="create-test-section-btn"
//                     style={{ marginRight: "18px", width: "160px" }}
//                     onClick={handleGenerateCode}
//                   >
//                     GENERATE CODE
//                   </button>
//                 )}
//                 <button
//                   className="create-test-section-btn"
//                   style={{
//                     marginRight: "18px",
//                     boxShadow: "0px 4px 4px 0px #00000040",
//                   }}
//                   onClick={() => navigate(-1)}
//                 >
//                   CANCEL
//                 </button>

//                 {isReadOnly && !isCancelled && (
//                   <button
//                     className="create-test-section-btn"
//                     style={{ marginRight: "18px" }}
//                     onClick={() => setShowCancelModal(true)}
//                   >
//                     DELETE
//                   </button>
//                 )}
//                 <button
//                   className="create-test-section-btn"
//                   style={{
//                     marginRight: "18px",
//                     boxShadow: "0px 4px 4px 0px #00000040",
//                     cursor: (isCancelled || isTestWindowEnded) ? "not-allowed" : "pointer",
//                     opacity: (isCancelled || isTestWindowEnded) ? 0.6 : 1,
//                   }}
//                   onClick={(!isCancelled && !isTestWindowEnded) ? handleEditSaveClick : undefined}
//                   disabled={isCancelled || isTestWindowEnded}
//                   title={isTestWindowEnded ? "Cannot edit: Test window has ended" : ""}
//                 >
//                   {isReadOnly ? "EDIT" : "SAVE"}
//                 </button>

//                 <button
//                   className="create-test-section-btn"
//                   style={{ marginRight: '0px' }}
//                   onClick={() => setOpen(true)}
//                 >
//                   DOWNLOAD
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         <PrintQuestionPaperModal
//           isOpen={open}
//           onClose={() => setOpen(false)}
//           testScheduleId={testScheduleId}
//           token={accessToken}
//           fileName={testNameUserPart}
//         />
//         <div
//           className="Header-1-C424342"
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "5px",
//           }}
//         >
//           <span>TEST INFORMATION</span>
//           {bodyVisible ? (
//             <img
//               src={MinusImg}
//               alt="Toggle"
//               style={{ cursor: "pointer", width: "24px", height: "10px" }}
//               onClick={toggleBodyVisible}
//             />
//           ) : (
//             <div
//               className="plus"
//               style={{
//                 cursor: "pointer",
//                 fontSize: "28px",
//                 width: "24px",
//                 height: "24px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#888",
//                 fontWeight: "bold",
//               }}
//               onClick={toggleBodyVisible}
//             >
//               +
//             </div>
//           )}
//         </div>
//         {bodyVisible && (
//           <div className="Body-1-C424342" style={{ paddingBottom: 10 }}>
//             {/* Row 1: Test Series | Description | Course */}
//             <div className="row-cs-uni" style={{ alignItems: "flex-start" }}>
//               <div style={{ width: "31.1%" }}>
//                 <ReflectDropdown
//                   label="Test Series"
//                   style={{ width: "100%" }}
//                   setSelected={handleTestSeriesSelect}
//                   selected={selectedTestSeries}
//                   options={[
//                     { label: "-None-", id: 0 },
//                     ...testSeries.map((ts) => ({
//                       label: `${ts.ts_name} / ${ts.course_name}`,
//                       id: ts.ts_id,
//                     })),
//                   ]}
//                   isRequired={false}
//                   isDisabled={true}
//                 />
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
//                 <InputComponent
//                   label="Description"
//                   style={{ width: "100%", opacity: "0.8" }}
//                   value={testSeriesDescription}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
//                 <DropDown3
//                   label="Course"
//                   style={{ width: "100%" }}
//                   setSelected={setCourseOpted}
//                   selected={courseOpted}
//                   options={courses.map((course) => ({
//                     label: course.course_name,
//                     id: course.course_id,
//                   }))}
//                   isRequired={false}
//                   disabled={true}
//                 />
//               </div>
//             </div>

//             {/* Row 2: Session | Class | Scope */}
//             <div className="row-cs-uni">
//               <div style={{ width: "31.1%" }}>
//                 <DropDown
//                   label="Session"
//                   style={{ width: "100%" }}
//                   setSelected={setSelectedSession}
//                   options={sessionOptions}
//                   isRequired={false}
//                   disabled={true}
//                 />
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
//                 <MultiSelectSearchDropdown3
//                   label="Class"
//                   width="100%"
//                   marginLeft="0"
//                   selected={selectedClass}
//                   setSelected={setSelectedClass}
//                   options={classOptions}
//                   isRequired={false}
//                   disabled={true}
//                 />
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
//                 <DropDown3
//                   label="Scope"
//                   style={{ width: "100%" }}
//                   selected={selectScope}
//                   setSelected={(value) => {
//                     setSelectedScope(value);
//                     setScopeSelection([]);
//                   }}
//                   options={scopes.map((scope) => ({
//                     label: scope.ques_paper_scope_desc,
//                     id: scope.ques_paper_scope_id,
//                   }))}
//                   isRequired={false}
//                   disabled={isReadOnly}
//                 />
//               </div>
//             </div>

//             {/* Row 3: Scope Reference | Student Group | Question Paper Name */}
//             <div className="row-cs-uni">
//               <div style={{ width: "31.1%", opacity: isReadOnly ? 0.8 : 1 }}>
//                 {isReadOnly ? (
//                   <InputComponent
//                     label="Scope Reference"
//                     style={{ width: "100%" }}
//                     value={isScopeGroup ? "N/A (Group scope)" : scopeRefNAMES}
//                     isRequired={false}
//                     disable={true}
//                   />
//                 ) : (
//                   <MultiSelectSearchDropdown
//                     label="Scope Reference"
//                     width="100%"
//                     marginLeft="0"
//                     selected={scopeSelection}
//                     setSelected={setScopeSelection}
//                     options={scopeSpecificData}
//                     isRequired={!isScopeGroup}
//                     placeholder={isScopeGroup ? "Disabled for Group scope" : `Select ${getScopeLabel(selectScope)}...`}
//                     singleSelect={false}
//                     disabled={isScopeGroup}
//                   />
//                 )}
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%", opacity: isReadOnly ? 0.8 : 1 }}>
//                 {isReadOnly ? (
//                   <InputComponent
//                     label="Student Group"
//                     style={{ width: "100%" }}
//                     value={studentGroupNames || "None"}
//                     isRequired={false}
//                     disable={true}
//                   />
//                 ) : (
//                   <>
//                     <MultiSelectSearchDropdown
//                       label={
//                         studentGroupsLoading ? (
//                           <>
//                             Student Group{" "}
//                             <span style={{ fontSize: 12, color: "#666", marginLeft: 6 }}>loading...</span>
//                           </>
//                         ) : (
//                           "Student Group"
//                         )
//                       }
//                       width="100%"
//                       marginLeft="0"
//                       selected={selectedStudentGroup}
//                       setSelected={(val) => {
//                         setSelectedStudentGroup(val);
//                         if (Array.isArray(val) && val.length > 0) {
//                           const matchingGroups = allStudentGroups.filter((g) => val.includes(g.id));
//                           setStudentGroupNames(matchingGroups.map((g) => g.label).join(", "));
//                         } else {
//                           setStudentGroupNames("");
//                         }
//                       }}
//                       options={getFilteredStudentGroups().map((g) => ({ label: g.label, id: g.id }))}
//                       isRequired={isScopeGroup}
//                       placeholder="Select Student Group..."
//                       singleSelect={false}
//                       onSearchInputChange={searchStudentGroups}
//                       disabled={false}
//                     />
//                     {studentGroupsError && (
//                       <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>{studentGroupsError}</div>
//                     )}
//                   </>
//                 )}
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%", opacity: isReadOnly ? 0.8 : 1 }}>
//                 <InputComponent
//                   label="Question Paper Name"
//                   style={{ width: "100%" }}
//                   value={QUESTIONPaperName}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>
//             </div>

//             {/* Row 4: Question Paper Description | Subjects | Question Paper Created By */}
//             <div className="row-cs-uni">
//               <div style={{ width: "31.1%", opacity: isReadOnly ? 0.8 : 1 }}>
//                 <InputComponent
//                   label="Question Paper Description"
//                   style={{ width: "100%" }}
//                   value={quesPaperDescription}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%", opacity: isReadOnly ? 0.8 : 1 }}>
//                 <InputComponent
//                   label="Subjects"
//                   style={{ width: "100%" }}
//                   value={testSeriesSubjects}
//                   isRequired={false}
//                   disable={true}
//                   icon={introgativeImgBlue}
//                 />
//               </div>

//               <div style={{ width: "31.1%", marginLeft: "3.2%", opacity: isReadOnly ? 0.8 : 1 }}>
//                 <InputComponent
//                   label="Question Paper Created By"
//                   style={{ width: "100%" }}
//                   value={quesPaperCreatedBy}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         <div
//           className="Header-1-C424342"
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "5px",
//             marginTop: "20px",
//           }}
//         >
//           <span>TEST SCHEDULING</span>
//           {schedulingVisible ? (
//             <img
//               src={MinusImg}
//               alt="Toggle"
//               style={{ cursor: "pointer", width: "24px", height: "10px" }}
//               onClick={toggleSchedulingVisible}
//             />
//           ) : (
//             <div
//               className="plus"
//               style={{
//                 cursor: "pointer",
//                 fontSize: "28px",
//                 width: "24px",
//                 height: "24px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#888",
//                 fontWeight: "bold",
//               }}
//               onClick={toggleSchedulingVisible}
//             >
//               +
//             </div>
//           )}
//         </div>
//         {schedulingVisible && (
//           <div
//             style={{
//               position: "relative",
//               opacity: isReadOnly ? 0.6 : 1,
//               pointerEvents: isReadOnly ? "none" : "auto",
//             }}
//           >
//             <div className="Body-1-C424342">
//               <div className="row-cs-uni">
//                 <div className="col-cs3-5">
//                   <label
//                     style={{
//                       color: "#6A6A6A",
//                       marginBottom: "6px",
//                       display: "block",
//                     }}
//                   >
//                     Test Name
//                   </label>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       border: "1px solid #a4a4a4",
//                     }}
//                   >
//                     {testSeriesPrefix && (
//                       <span
//                         style={{
//                           color: `${Colors.color3}`,
//                           marginRight: "5px",
//                         }}
//                       >
//                         {testSeriesPrefix}
//                       </span>
//                     )}
//                     <input
//                       type="text"
//                       value={testNameUserPart}
//                       onChange={(e) => setTestNameUserPart(e.target.value)}
//                       placeholder="Enter test name"
//                       style={{
//                         flex: 1,
//                         border: "none",
//                         outline: "none",
//                         fontSize: "inherit",
//                         color: `${Colors.color3}`,
//                         height: "28px",
//                         paddingLeft: "5px",
//                       }}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-cs">
//                   <div style={{ marginLeft: "3.6%", marginTop: "2px" }}>
//                     <label
//                       style={{
//                         color: `${Colors.color3}`,
//                         marginBottom: "4px",
//                         display: "block",
//                       }}
//                     >
//                       Description
//                     </label>
//                     <input
//                       className="date-CB2"
//                       id="description"
//                       name="description"
//                       placeholder="Enter description"
//                       value={testDescription}
//                       onChange={(e) => setTestDescription(e.target.value)}
//                       style={{
//                         width: "99.8%",
//                         padding: "5px",
//                         color: `${Colors.color3}`,
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="row-cs-uni" style={{ marginTop: "7px" }}>
//                 <div className="col-cs-uni">
//                   <div style={{ marginBottom: "5px" }}>
//                     <label style={{ color: `${Colors.color3}` }}>
//                       Test Window Start
//                     </label>
//                     {/* ─── UPDATED: min attr enforces server time + 15 min in the picker ── */}
//                     <input
//                       className="date-CB2-3"
//                       type="datetime-local"
//                       id="testWindowStart"
//                       name="testWindowStart"
//                       value={testStartDate}
//                       min={getCurrentDateTime()}
//                       onChange={(e) => {
//                         setTestStartDate(e.target.value);
//                       }}
//                       style={{ color: `${Colors.color3}` }}
//                     />
//                   </div>

//                   <InputComponent
//                     label="Test Coordinator"
//                     style={{
//                       width: "93.3%",
//                       opacity: "0.8",
//                     }}
//                     value={testCoordinator}
//                     isRequired={false}
//                     disable={true}
//                   />

//                   <div style={{ marginTop: "8px" }}>
//                     <DropDown2
//                       label="Shuffle Subjects"
//                       style={{ width: "93.3%" }}
//                       selected={shuffleSubjects}
//                       setSelected={(newValue) => {
//                         if (isOfflineMode() && newValue !== shuffleSubjects) {
//                           showOfflineWarning(
//                             "Changing shuffle subjects setting"
//                           );
//                         }
//                         setShuffleSubjects(newValue);
//                       }}
//                       options={[
//                         { id: 1, label: "Yes" },
//                         { id: 0, label: "No" },
//                       ]}
//                       isRequired={false}
//                       disabled={numberOfSets < 2}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-cs-uni">
//                   <div style={{ marginBottom: "4px", marginLeft: "3.2%", marginRight: "3px", }} >
//                     <label style={{ color: "GrayText" }}>
//                       Test Window End <span style={{ color: `${Colors.color15}` }}>*</span>
//                     </label>
//                     {/* <span style={{ fontStyle: "italic", color: "#888", fontSize: "12px",  marginLeft: testEndDate ? "6px" : "15px"  }}>
//                       {testEndDate
//                       ?`Test will auto-submit at ${new Date(testEndDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}. Students can't attempt after this.`
//                       : "Student's test will be auto-submitted once the test window ends."
//                     }
//                     </span> */}
//                     <input
//                       className="date-CB3"
//                       type="datetime-local"
//                       id="testWindowEnd"
//                       name="testWindowEnd"
//                       min={
//                         testStartDate
//                           ? getMinEndDateTime(testStartDate)
//                           : getCurrentDateTime()
//                       }
//                       value={testEndDate}
//                       onChange={(e) => {
//                         setTestEndDate(e.target.value);
//                       }}
//                       style={{ color: `${Colors.color3}` }}
//                     />
//                   </div>

//                   <ReflectDropdown
//                     label="Test Mode"
//                     style={{ width: "93.1%", marginLeft: "3.2%" }}
//                     setSelected={handleTestModeChange}
//                     selected={testMode}
//                     options={[
//                       { id: 1, label: "Online (with test code)" },
//                       { id: 2, label: "Online (without test code)" },
//                       { id: 3, label: "Offline" },
//                     ]}
//                     isRequired={false}
//                     isDisabled={isReadOnly || !canChangeTestMode()}
//                   />

//                   <DropDown2
//                     label="Shuffle Questions"
//                     style={{
//                       width: "93.1%",
//                       marginLeft: "3.2%",
//                       marginTop: "8px",
//                     }}
//                     selected={shuffleQuestions}
//                     setSelected={setShuffleQuestions}
//                     options={[
//                       { id: 1, label: "Yes" },
//                       { id: 0, label: "No" },
//                     ]}
//                     isRequired={false}
//                     disabled={numberOfSets < 2}
//                   />
//                 </div>
//                 <div className="col-cs-uni">
//                   <div style={{ width: "94.9%", marginLeft: "1.9%" }}>
//                     <label
//                       style={{
//                         marginBottom: "6px",
//                         display: "block",
//                         color: "GrayText",
//                       }}
//                     >
//                       Duration
//                     </label>
//                     <div style={{ position: "relative", width: "100%" }}>
//                       <input
//                         placeholder="( In minutes )"
//                         type="number"
//                         className="time-input2"
//                         value={timeMinutes}
//                         onChange={handleInputChange}
//                         style={{ width: "100%", paddingRight: "50px" }}
//                       />
//                       <div
//                         className="time-display"
//                         style={{
//                           position: "absolute",
//                           right: "10px",
//                           top: "35%",
//                           transform: "translateY(-50%)",
//                           color: `${Colors.color2}`,
//                         }}
//                       >
//                         {time} hr
//                       </div>
//                     </div>
//                   </div>

//                   <DropDown2
//                     label="Number of Sets"
//                     style={{ width: "94.8%", marginLeft: "1.9%" }}
//                     selected={numberOfSets}
//                     setSelected={(newValue) => {
//                       if (isOfflineMode() && newValue !== numberOfSets) {
//                         showOfflineWarning("Changing number of sets");
//                       }
//                       setNumberOfSets(newValue);
//                     }}
//                     options={[
//                       { id: 1, label: "1" },
//                       { id: 2, label: "2" },
//                       { id: 3, label: "3" },
//                       { id: 4, label: "4" },
//                       { id: 5, label: "5" },
//                       { id: 6, label: "6" },
//                     ]}
//                     isRequired={false}
//                     disabled={isReadOnly}
//                   />

//                   <DropDown2
//                     label="Shuffle Options"
//                     style={{
//                       width: "94.8%",
//                       marginLeft: "1.9%",
//                       marginTop: "10px",
//                     }}
//                     selected={shuffleOptions}
//                     setSelected={setShuffleOptions}
//                     options={[
//                       { id: 1, label: "Yes" },
//                       { id: 0, label: "No" },
//                     ]}
//                     isRequired={false}
//                     disabled={true}
//                   />
//                 </div>
//               </div>

//               <div
//                 style={{
//                   width: "99%",
//                   marginBottom: "20px",
//                   opacity: !canChangeInstructions() ? 0.6 : 1,
//                   pointerEvents: !canChangeInstructions() ? "none" : "auto",
//                 }}
//               >
//                 <TextEditor
//                   templates={testTemplates}
//                   value={instructionsHtml}
//                   setValue={handleInstructionsChange}
//                   disabled={!canChangeInstructions()}
//                 />
//               </div>
//             </div>

//             {isReadOnly && (
//               <div
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   width: "100%",
//                   height: "100%",
//                   zIndex: 10,
//                 }}
//               />
//             )}
//           </div>
//         )}

//         <div style={{ marginBottom: "100px" }}>
//           <div
//             className="Header-1-C424342"
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "5px",
//               marginTop: "20px",
//             }}
//           >
//             <span>MARKING SCHEME </span>
//             {markingSchemeVisible ? (
//               <img
//                 src={MinusImg}
//                 alt="Toggle"
//                 style={{ cursor: "pointer", width: "24px", height: "10px" }}
//                 onClick={toggleMarkingSchemeVisible}
//               />
//             ) : (
//               <div
//                 className="plus"
//                 style={{
//                   cursor: "pointer",
//                   fontSize: "28px",
//                   width: "24px",
//                   height: "24px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: `${Colors.color3}`,
//                   fontWeight: "bold",
//                 }}
//                 onClick={toggleMarkingSchemeVisible}
//               >
//                 +
//               </div>
//             )}
//           </div>
//           {markingSchemeVisible && (
//             <div
//               className="Body-1-C424342"
//               style={{
//                 padding: "15px",
//                 color: `${Colors.color1}`,
//                 marginBottom: "100px",
//               }}
//             >
//               {markingSchemeFromAPI.map((subjectData) => {
//                 const subjectName = subjectData.subject_name;

//                 const sectionKeys = Object.keys(subjectData).filter((key) =>
//                   key.startsWith("ms_id_sec_")
//                 );

//                 return sectionKeys.map((key, index) => {
//                   const sectionLabel = `Section ${String.fromCharCode(
//                     65 + index
//                   )}`;
//                   const selectedId = subjectData[key];
//                   const scheme = markingSchemeList.find(
//                     (ms) => ms.ms_id === selectedId
//                   );

//                   return (
//                     <div
//                       className="row-cs"
//                       key={`${subjectName}-${sectionLabel}`}
//                       style={{ marginBottom: "12px", fontSize: "14px" }}
//                     >
//                       <div
//                         className="col-cs"
//                         style={{
//                           paddingRight: "10px",
//                           opacity: !isReadOnly ? 1 : 0.9,
//                           color: !isReadOnly ? Colors.color1 : Colors.color11,
//                         }}
//                       >
//                         <div style={{ marginTop: "10px" }}>
//                           {subjectName} - {sectionLabel}
//                         </div>
//                       </div>

//                       <div
//                         className="col-cs"
//                         style={{
//                           paddingRight: "10px",
//                           marginTop: "0px !important",
//                         }}
//                       >
//                         <ReflectDropdown
//                           style={{ width: "100%", marginLeft: "1%" }}
//                           options={markingSchemeList.map((ms) => ({
//                             label: ms.ms_name,
//                             id: ms.ms_id,
//                           }))}
//                           selected={
//                             selectedMarkingSchemes?.[
//                             `${subjectName}-${index + 1}`
//                             ] ?? selectedId
//                           }
//                           setSelected={(val) => {
//                             if (!isReadOnly) {
//                               updateAllSectionsOfSameType(index, val);
//                             }
//                           }}
//                           isDisabled={isReadOnly}
//                         />
//                       </div>

//                       <div className="col-cs">
//                         <div
//                           style={{
//                             marginBottom: "4px",
//                             color: `${Colors.color1}`,
//                             marginLeft: "3%",
//                             marginTop: "13px",
//                             opacity: !isReadOnly ? 1 : 0.9,
//                             color: !isReadOnly ? Colors.color1 : Colors.color11,
//                           }}
//                         >
//                           {scheme
//                             ? `${scheme.expression} ; ${scheme.ms_desc}`
//                             : "—"}
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 });
//               })}
//             </div>
//           )}
//         </div>
//       </div >

//       <RejectModal
//         isOpen={showCancelModal}
//         onClose={() => setShowCancelModal(false)}
//         onSubmit={handleCancelTestSchedule}
//         title="Cancel Test Schedule"
//         placeholder="Enter reason for cancelling the test schedule..."
//         setMessageBox={setMessageBox}
//         setIsMessageBoxVisible={setIsMessageBoxVisible}
//         setActiveImg={setActiveImg}
//         errorImg={ErrorImg}
//       />

//       <TestPrintModal
//         isOpen={showPrintModal}
//         onClose={() => setShowPrintModal(false)}
//         testScheduleId={testScheduleId}
//         selectedSet={selectedPrintSet}
//       />
//     </>
//   );
// };

// export default TestSchedulingClone;

import React, { useRef, useState, useEffect } from "react";
import "./testscheduling.css";
import DropDown from "./Dropwon-testscheduling";
import DropDown2 from "./Dropdwon-Shuffle";
import DropDown3 from "./Drodpwon-Catch";
import InputComponent from "./Input-testscheduling";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
import DateComponent from "./DateComponent";
import CalenderImg from "../../../Assets/Images/CommanImages/CalenderImg.png";
import TextEditor from "../../Landing/components/TextEditor";
import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
import MultiSelectSearchDropdown2 from "./Mulit-Dropdwon";
import MultiSelectSearchDropdown3 from "./MulitSelectDropDown3";
import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import Colors from "../../../Constants/Colors";
import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
import { useNavigate } from "react-router-dom";
import { PUT, GET, POST } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/EndPoints";
import { useSearchParams } from "react-router-dom";
import RejectModal from "../../../Components/RejectModal/RejectModal";
import TestPrintModal from "../../../Components/Modals/PreviewforTestSchedule";
import PrintQuestionPaperModal from "../../../Components/Modals/PrintQuestionPaperModal";

const TestSchedulingClone = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) => {
  const navigate = useNavigate();
  const [scopeSpecificData, setScopeSpecificData] = useState([]);
  const [scopeSelection, setScopeSelection] = useState([]);
  const [scopeRefDisplay, setScopeRefDisplay] = useState("");
  const [scopeRefNAMES, setscopeRefNAMES] = useState([]);
  const [initialScopeRefIds, setInitialScopeRefIds] = useState([]);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedPrintSet, setSelectedPrintSet] = useState("A");

  // ─── SERVER CURRENT TIME STATE ───────────────────────────────────────────────
  const [serverCurrentTime, setServerCurrentTime] = useState(null);

  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";

  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;

  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  const [selectedCoordinatorOption, setSelectedCoordinatorOption] =
    useState(null);

  const [searchParams] = useSearchParams();
  const testScheduleId = searchParams.get("IDs");

  const [markingSchemeFromAPI, setMarkingSchemeFromAPI] = useState([]);

  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleEditSaveClick = () => {
    if (!isReadOnly) {
      // When saving, don't flip isReadOnly here —
      // handleSave will flip it only on success
      handleSave();
      return;
    }
    // Entering edit mode
    setIsReadOnly(false);
  };

  const [testSeriesPrefix, setTestSeriesPrefix] = useState("");
  const [testNameUserPart, setTestNameUserPart] = useState("");
  const [testDescription, setTestDescription] = useState("");

  const [scopeRefID, setScopeRefID] = useState("");

  const [showCancelModal, setShowCancelModal] = useState(false);

  const [quesPaperScopeID, setquesPaperScopeID] = useState("");
  const [shuffleSubjects, setShuffleSubjects] = useState(0);
  const [shuffleQuestions, setShuffleQuestions] = useState(1);
  const [shuffleOptions, setShuffleOptions] = useState(0);
  const [markingSchemeList, setMarkingSchemeList] = useState([]);
  const [markingSchemeCount, setMarkingSchemeCount] = useState(1);
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [paperSubjects, setPaperSubjects] = useState([]);

  const [ChangedTestCoordinator, setChangedTestCoordinator] = useState("");
  const [showMarkingScheme, setShowMarkingScheme] = useState(false);
  const [testSeriesSubjects, setTestSeriesSubjects] = useState("");
  const [testSeriesDescription, setTestSeriesDescription] = useState("");
  const [numberOfSets, setNumberOfSets] = useState(1);
  const [subjects, setSubjects] = useState("");
  const [selectedTestSeries, setSelectedTestSeries] = useState(null);
  const [testSeries, setTestSeries] = useState([]);
  const [testStartDate, setTestStartDate] = useState(null);
  const [testEndDate, setTestEndDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [scopes, setScopes] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [CordinatorName, setCordinatorName] = useState("Shashi,Parser");
  const [testMode, setTestMode] = useState(1);
  const normalizedTestMode = testMode !== null ? Number(testMode) : "";
  const [testSearchKey, setTestSearchKey] = useState("");
  const [sessionOptions, setSessionOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [allScopeData, setAllScopeData] = useState([]);
  const [testTemplates, setTestTemplates] = useState([]);

  const accessToken = localStorage.getItem("other");
  const [time, setTime] = useState("");
  const [timeMinutes, setTimeMinutes] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [selectScope, setSelectedScope] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [testName, setTestName] = useState(null);
  const [formData, setFormData] = useState({});
  const [testNames, setTestNames] = useState([]);
  const [facultyList, setFacultyList] = useState([]);

  const [testCoordinator, setTestCoordinator] = useState(null);
  const [quesPaperList, setQuesPaperList] = useState([]);
  const [selectedQuesPaper, setSelectedQuesPaper] = useState(null);
  const [quesPaperDescription, setQuesPaperDescription] = useState("");
  const [quesPaperCreatedBy, setQuesPaperCreatedBy] = useState("");
  const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState(
    Array(markingSchemeCount).fill(null)
  );
  const [open, setOpen] = useState(false);

  const scopeId =
    selectScope && typeof selectScope === "object"
      ? selectScope.id
      : selectScope;

  const isScopeGroup = Number(scopeId) === 9;

  const [bodyVisible, setBodyVisible] = useState(true);
  const [schedulingVisible, setSchedulingVisible] = useState(true);
  const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);
  const isTestSeriesNone =
    selectedTestSeries === 0 || selectedTestSeries === null;

  const toggleBodyVisible = () => {
    setBodyVisible(!bodyVisible);
  };
  const toggleSchedulingVisible = () => {
    setSchedulingVisible(!schedulingVisible);
  };
  const toggleMarkingSchemeVisible = () => {
    setMarkingSchemeVisible(!markingSchemeVisible);
  };

  const handleInputChange = (e) => {
    const minutes = e.target.value;
    const hours = (minutes / 60).toFixed(2);
    setTime(hours);
    setTimeMinutes(minutes);
  };

  const [CurrentTimeFromServer, setCurrentTimeFromServer] = useState(null);

  // Student group states
  const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
  const [allStudentGroups, setAllStudentGroups] = useState([]);
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [initialStudentGroupIds, setInitialStudentGroupIds] = useState([]);
  const [studentGroupNames, setStudentGroupNames] = useState("");
  const [studentGroupsLoading, setStudentGroupsLoading] = useState(false);
  const [studentGroupsError, setStudentGroupsError] = useState(null);
  const [isTestWindowEnded, setIsTestWindowEnded] = useState(false);

  // ── Refs that hold the LAST SAVED start/end dates ─────────────────────────
  // Used as reference points for validation so that unsaved changes don't
  // affect the comparison baseline. Initialized when data loads from API.
  const savedStartDateRef = useRef(null);
  const savedEndDateRef = useRef(null);

  // ─── FETCH SERVER CURRENT TIME ────────────────────────────────────────────────
  useEffect(() => {
    const fetchServerTime = async () => {
      try {
        const response = await GET.withToken(EndPoints.GetCurrentDateTime, {
          setMessageBox,
          setIsMessageBoxVisible,
          setActiveImg,
          ErrorImg,
        });

        if (response?.status === 200 && response?.data) {
          const { current_date, current_time } = response.data;
          // Combine into a single datetime string: "2026-05-19T14:30:00"
          const combined = `${current_date}T${current_time}`;
          setServerCurrentTime(combined);
        }
      } catch (error) {
        console.error("Error fetching server time:", error);
        // Fallback to browser time if server time fetch fails
        setServerCurrentTime(new Date().toISOString());
      }
    };

    fetchServerTime();
  }, []);

  // ─── HELPER: GET CURRENT DATETIME + 15 MIN BUFFER (from server) ───────────────
  const getCurrentDateTime = () => {
    const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date(); // fallback to browser time if server time not yet loaded
    base.setMinutes(base.getMinutes() + 15); // +15 minutes buffer
    const year = base.getFullYear();
    const month = String(base.getMonth() + 1).padStart(2, "0");
    const day = String(base.getDate()).padStart(2, "0");
    const hours = String(base.getHours()).padStart(2, "0");
    const minutes = String(base.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  // Add this useEffect to populate description from test series
  useEffect(() => {
    if (!selectedTestSeries || !testSeries.length) return;

    const selectedSeries = testSeries.find(
      (ts) => ts.ts_id === Number(selectedTestSeries)
    );

    if (selectedSeries?.ts_desc) {
      setTestSeriesDescription(selectedSeries.ts_desc);
    }
  }, [selectedTestSeries, testSeries]);

  // Fetch test schedule details
  useEffect(() => {
    const fetchTestScheduleDetails = async () => {
      if (!testScheduleId) return;

      const url = `${EndPoints.GetTestSchedulebyIdv1}?test_schedule_id=${testScheduleId}`;

      const response = await GET.withToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      const data = response?.data;
      if (data) {
        setSelectedTestSeries(data.ts_id);
        setScopeRefID(data.scope_ref_id || "");
        setQuesPaperDescription(data.ques_paper_desc || "");
        setQuesPaperCreatedBy(data.ques_paper_created_by || "");
        setTestNameUserPart(data.test_name || "");
        setTestDescription(data.test_desc || "");
        setCurrentTimeFromServer(data.current_time || "");

        // Check if test window has ended
        if (data.current_time && data.test_window_end) {
          const currentTime = new Date(data.current_time);
          const testEndTime = new Date(data.test_window_end);
          setIsTestWindowEnded(currentTime > testEndTime);
        }

        if (data.ques_paper_id && data.ques_paper_name) {
          setSelectedQuesPaper({
            id: data.ques_paper_id,
            label: data.ques_paper_name,
          });
        }

        if (data.scope_ref_id_list && Array.isArray(data.scope_ref_id_list)) {
          setInitialScopeRefIds(data.scope_ref_id_list);
          setScopeSelection(data.scope_ref_id_list);
        }

        if (
          data.student_group_id_list &&
          Array.isArray(data.student_group_id_list)
        ) {
          const groupIds = data.student_group_id_list.map((g) =>
            typeof g === "object" ? g.student_group_id : g
          );
          setInitialStudentGroupIds(groupIds);
          setSelectedStudentGroup(groupIds);

          const groupNames = data.student_group_id_list
            .map((g) => (typeof g === "object" ? g.student_group_name : ""))
            .filter(Boolean)
            .join(", ");
          setStudentGroupNames(groupNames);
        }

        if (data.ques_paper_scope_id) {
          setquesPaperScopeID(data.ques_paper_scope_id);
        }

        if (data.subject_id_list && Array.isArray(data.subject_id_list)) {
          const subjectNames = data.subject_id_list.map(
            (subject) => subject.subject_name
          );
          setTestSeriesSubjects(subjectNames.join(", "));
        }

        const formatDateForInput = (isoString) => {
          if (!isoString) return "";
          if (isoString.length === 19 && isoString.includes("T")) {
            return isoString.slice(0, 16);
          }
          const date = new Date(isoString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");

          return `${year}-${month}-${day}T${hours}:${minutes}`;
        };

        const formattedStart = formatDateForInput(data.test_window_start);
        const formattedEnd = formatDateForInput(data.test_window_end);
        setTestStartDate(formattedStart);
        setTestEndDate(formattedEnd);
        // Store last saved values — used as validation baseline
        savedStartDateRef.current = formattedStart;
        savedEndDateRef.current = formattedEnd;
        setTimeMinutes(data.duration || "");
        setTime((data.duration / 60).toFixed(2) || "");
        setTestCoordinator(data.test_coordinator_name || null);
        setChangedTestCoordinator(data.test_coordnator_emp_id || null);
        setTestMode(data.test_mode || 1);
        setNumberOfSets(data.no_of_sets || 1);
        setInstructionsHtml(data.instructions_html || "");
        setShuffleQuestions(data.shuffle_questions ? 1 : 0);
        setShuffleSubjects(data.shuffle_subjects ? 1 : 0);
        setShuffleOptions(data.shuffle_options ? 1 : 0);

        setMarkingSchemeFromAPI(data.marking_scheme || []);
      }
    };

    fetchTestScheduleDetails();
  }, [testScheduleId]);

  // Fetch student groups
  useEffect(() => {
    const fetchStudentGroups = async () => {
      if (!clientBranchId) return;

      try {
        setStudentGroupsLoading(true);
        setStudentGroupsError(null);

        const url = `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`;

        const resp = await fetch(url, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (resp.status === 401 || resp.status === 403) {
          setStudentGroupsError("Not authenticated. Please login.");
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
          return;
        }

        const json = await resp.json();

        if (
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const options = json.data.map((group) => ({
            id: group.student_group_id,
            label: group.student_group_name,
            session_id: group.session_id || "",
            course_id: group.course_id || "",
          }));
          setStudentGroupsOptions(options);
          setAllStudentGroups(options);
        } else {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
        }
      } catch (err) {
        console.error("Error fetching student groups:", err);
        setStudentGroupsError(err.message || "Error");
        setStudentGroupsOptions([]);
        setAllStudentGroups([]);
      } finally {
        setStudentGroupsLoading(false);
      }
    };
    fetchStudentGroups();
  }, [clientBranchId, accessToken]);

  // Update student group names when options load
  useEffect(() => {
    if (
      allStudentGroups.length > 0 &&
      initialStudentGroupIds.length > 0 &&
      !studentGroupNames
    ) {
      const matchingGroups = allStudentGroups.filter((g) =>
        initialStudentGroupIds.includes(g.id)
      );
      if (matchingGroups.length > 0) {
        setStudentGroupNames(matchingGroups.map((g) => g.label).join(", "));
      }
    }
  }, [allStudentGroups, initialStudentGroupIds, studentGroupNames]);

  // Client-side filtering for student groups
  const searchStudentGroups = (searchKey) => {
    const selectedCourseId = courseOpted
      ? typeof courseOpted === "object"
        ? courseOpted.id
        : courseOpted
      : null;

    let filtered = allStudentGroups;
    if (selectedCourseId) {
      filtered = filtered.filter((g) => g.course_id === selectedCourseId);
    }

    if (searchKey && searchKey.trim() !== "") {
      filtered = filtered.filter((g) =>
        g.label.toLowerCase().includes(searchKey.toLowerCase())
      );
    }

    setStudentGroupsOptions(filtered);
  };

  const getFilteredStudentGroups = () => {
    if (!courseOpted) return studentGroupsOptions;

    const selectedCourseId =
      typeof courseOpted === "object" ? courseOpted.id : courseOpted;
    return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
  };

  useEffect(() => {
    if (isScopeGroup && !isReadOnly) {
      setScopeSelection([]);
    }
  }, [isScopeGroup, isReadOnly]);

  useEffect(() => {
    if (scopeSpecificData.length > 0 && initialScopeRefIds.length > 0) {
      const matchingOptions = scopeSpecificData.filter((option) =>
        initialScopeRefIds.includes(option.id)
      );

      if (matchingOptions.length > 0) {
        const displayNames = matchingOptions.map((opt) => opt.label).join(", ");
        setscopeRefNAMES(displayNames);
      }
    }
  }, [scopeSpecificData, initialScopeRefIds]);

  useEffect(() => {
    if (
      !selectedTestSeries ||
      !courses.length ||
      !scopes.length ||
      !sessionOptions.length ||
      !classOptions.length
    )
      return;

    const selectedSeries = testSeries.find(
      (ts) => ts.ts_id === Number(selectedTestSeries)
    );

    if (!selectedSeries) return;

    const course = courses.find(
      (c) => c.course_id === selectedSeries.course_id
    );
    if (course) {
      setCourseOpted({ id: course.course_id, label: course.course_name });
    }

    const scope = scopes.find(
      (s) => s.ques_paper_scope_id === selectedSeries.scope_id
    );
    if (scope) {
      setSelectedScope({
        id: scope.ques_paper_scope_id,
        label: scope.ques_paper_scope_desc,
      });
    }

    const session = sessionOptions.find(
      (s) => s.id === selectedSeries.session_name
    );
    if (session) {
      setSelectedSession(session.id);
    }

    if (Array.isArray(selectedSeries.class_id_list)) {
      const matchedClasses = selectedSeries.class_id_list
        .map((id) => {
          const cls = classOptions.find((c) => c.id === id);
          return cls ? cls.id : null;
        })
        .filter(Boolean);

      if (matchedClasses.length) {
        setSelectedClass(matchedClasses);
      }
    }
  }, [
    selectedTestSeries,
    testSeries,
    courses,
    scopes,
    sessionOptions,
    classOptions,
  ]);

  useEffect(() => {
    if (testScheduleId) return;

    const interval = setInterval(() => {
      if (!testSeries.length) return;

      const selectedSeries = testSeries.find(
        (ts) => ts.ts_id === Number(selectedTestSeries)
      );

      if (selectedSeries?.ts_desc) {
        setTestDescription(selectedSeries.ts_desc);
        clearInterval(interval);
      }
    }, 200);

    return () => clearInterval(interval);
  }, [selectedTestSeries, testSeries, testScheduleId]);

  useEffect(() => {
    if (!selectedTestSeries || !testSeries.length) return;

    const selectedSeries = testSeries.find(
      (ts) => ts.ts_id === Number(selectedTestSeries)
    );

    if (!selectedSeries?.scope_ref_ids?.length) return;

    const refIds = selectedSeries.scope_ref_ids.map((r) => r.id);

    const getLabel = (list, id) => {
      const found = list.find((item) => item.id === id);
      return found?.label || found?.batch_name || found?.name || "";
    };

    let scopeLabels = [];

    switch (selectedSeries.scope_id) {
      case 1:
        scopeLabels = refIds.map((id) => getLabel(batchData, id));
        break;
      case 2:
        scopeLabels = refIds.map((id) => getLabel(branchData, id));
        break;
      case 3:
        scopeLabels = refIds.map((id) => getLabel(zoneData, id));
        break;
      case 4:
        scopeLabels = refIds.map((id) => getLabel(cityData, id));
        break;
      case 5:
        scopeLabels = refIds.map((id) => getLabel(stateData, id));
        break;
      case 6:
        scopeLabels = refIds.map((id) => getLabel(selectedRegion, id));
        break;
      default:
        break;
    }

    const cleanLabels = scopeLabels.filter(Boolean);
  }, [
    selectedTestSeries,
    testSeries,
    batchData,
    branchData,
    zoneData,
    cityData,
    stateData,
    selectedRegion,
  ]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
        const data = await response.json();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching courses: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchScopes = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-list-of-scopes`,
          {
            headers: { accept: "application/json" },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const activeScopes = data.filter((scope) => scope.status === 1);
        setScopes(activeScopes);
      } catch (error) {
        console.error("Error fetching :", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching Scopes: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchScopes();
  }, []);

  // useEffect(() => {
  //   const fetchQuestionPaperList = async () => {
  //     try {
  //       const token = localStorage.getItem("other");
  //       const courseId = courseOpted
  //         ? typeof courseOpted === "object"
  //           ? courseOpted.id
  //           : courseOpted
  //         : "";
  //       let classQuery = "";
  //       if (Array.isArray(selectedClass) && selectedClass.length > 0) {
  //         classQuery = selectedClass.map((id) => `&class_id=${id}`).join("");
  //       }
  //       const response = await fetch(
  //         `${FULL_API_BASE_URL}/get-ques-paper-list/?branch_id=${clientBranchId}&course_id=${courseId}${classQuery}`,
  //         {
  //           headers: {
  //             accept: "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       const result = await response.json();
  //       if (result.status === 200) {
  //         setQuesPaperList(result.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching question paper list:", error);
  //     }
  //   };
  //   fetchQuestionPaperList();
  // }, [clientBranchId, courseOpted, selectedClass, userName]);

  useEffect(() => {
    const fetchQuestionPaperList = async () => {
      const courseId = courseOpted
        ? typeof courseOpted === "object"
          ? courseOpted.id
          : courseOpted
        : "";

      const classIds = Array.isArray(selectedClass) ? selectedClass : [];

      if (!clientBranchId || !courseId || classIds.length === 0) {
        return;
      }

      const classQuery = classIds.map((id) => `&class_id=${id}`).join("");

      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-ques-paper-list/?branch_id=${clientBranchId}&course_id=${courseId}${classQuery}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        if (result.status === 200) {
          setQuesPaperList(result.data);
        }
      } catch (error) {
        console.error("Error fetching question paper list:", error);
      }
    };
    fetchQuestionPaperList();
  }, [clientBranchId, courseOpted, selectedClass, userName]);
  
  useEffect(() => {
    if (selectScope !== null) {
      fetchScopeDetails();
    }
  }, [selectScope, courseOpted, selectedSession, selectedClass]);

  const fetchScopeDetails = async () => {
    const scopeId =
      typeof selectScope === "object" ? selectScope.id : selectScope;

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-scopes-details-all`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (data.status === 200) {
        let apiData = data.data;

        if (scopeId === 1 && courseOpted) {
          const selectedCourseId =
            typeof courseOpted === "object" ? courseOpted.id : courseOpted;
          apiData = apiData.filter(
            (item) => item.course_id === selectedCourseId
          );
        }

        if (selectedSession) {
          apiData = apiData.filter(
            (item) => item.session_name === selectedSession
          );
        }

        let scopeOptions = [];

        switch (scopeId) {
          case 1:
            scopeOptions = apiData.map((item) => ({
              id: item.batch_id,
              label: item.batch_name,
            }));
            break;

          case 2:
            scopeOptions = apiData.map((item) => ({
              id: item.branch_id,
              label: item.branch_name,
            }));
            break;

          case 3:
            scopeOptions = apiData.map((item) => ({
              id: item.city_zone_id,
              label: item.zone_name,
            }));
            break;

          case 4:
            scopeOptions = apiData.map((item) => ({
              id: item.city_id,
              label: item.city_name,
            }));
            break;

          case 5:
            scopeOptions = apiData.map((item) => ({
              id: item.state_id,
              label: item.state_name,
            }));
            break;

          case 7:
          case 8:
            scopeOptions = [
              {
                id: 1,
                label: "All India",
              },
            ];
            break;

          case 9:
            scopeOptions = [];
            break;

          default:
            scopeOptions = [];
        }

        scopeOptions = Array.from(
          new Map(scopeOptions.map((opt) => [opt.id, opt])).values()
        );

        setScopeSpecificData(scopeOptions);
      }
    } catch (error) {
      console.error("Error fetching scope details:", error);
      setScopeSpecificData([]);
    }
  };

  const getScopeLabel = (scopeId) => {
    const id = typeof scopeId === "object" ? scopeId.id : scopeId;
    switch (id) {
      case 1:
        return "Batch";
      case 2:
        return "Branch";
      case 3:
        return "Zone";
      case 4:
        return "City";
      case 5:
        return "State";
      case 7:
        return "All India (Internal)";
      case 8:
        return "All India (Open)";
      case 9:
        return "Group";
      default:
        return "Scope";
    }
  };

  useEffect(() => {
    const fetchTestSeries = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-test-series-list-by-branch/?client_branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        if (result.status === 200) {
          setTestSeries(result.data);

          if (selectedTestSeries) {
            const matched = result.data.find(
              (ts) => ts.ts_id === Number(selectedTestSeries)
            );
            if (matched) {
              handleTestSeriesSelect(matched.ts_id);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching test series:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching test series: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };

    if (clientBranchId && testScheduleId) {
      fetchTestSeries();
    }
  }, [clientBranchId, testScheduleId]);

  useEffect(() => {
    const fetchMarkingSchemes = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`,
          { headers: { accept: "application/json" } }
        );
        const result = await response.json();
        if (result.status_code === 200 || result.status === "success") {
          setMarkingSchemeList(result.data);
        }
      } catch (error) {
        console.error("Error fetching marking schemes:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching marking schemes: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };

    fetchMarkingSchemes();
  }, []);

  useEffect(() => {
    if (!paperSubjects?.length || !markingSchemeList?.length) return;

    const stored = sessionStorage.getItem("testScheduleDetails");
    if (!stored) return;

    const scheduleData = JSON.parse(stored);
    const msFromSchedule = scheduleData.marking_scheme || [];
    if (!Array.isArray(msFromSchedule)) return;

    const newSelections = {};

    paperSubjects.forEach((subject) => {
      const match = msFromSchedule.find(
        (ms) => ms.subject_id === subject.subject_id
      );
      if (!match) return;

      ["a", "b", "c", "d"].forEach((char, idx) => {
        const msId = match[`ms_id_sec_${char}`];
        if (msId) {
          const rowKey = `${subject.subject_name}-${idx + 1}`;
          newSelections[rowKey] = msId;
        }
      });
    });

    setSelectedMarkingSchemes(newSelections);
  }, [paperSubjects, markingSchemeList]);

  useEffect(() => {
    const fetchSessionsAndClasses = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-scopes-details-all/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (data.status === 200) {
          const apiData = data.data;
          const sessions = Array.from(
            new Set(apiData.map((item) => item.session_name))
          ).map((name) => ({ label: name, id: name }));

          const classes = Array.from(
            new Set(apiData.map((item) => item.class_id))
          ).map((id) => {
            const found = apiData.find((item) => item.class_id === id);
            return { label: found ? found.class_name : id, id: id };
          });

          classes.sort((a, b) => {
            const aNum = parseInt(a.label.replace(/\D/g, ""), 10);
            const bNum = parseInt(b.label.replace(/\D/g, ""), 10);
            if (!isNaN(aNum) && !isNaN(bNum)) {
              return aNum - bNum;
            }
            return a.label.localeCompare(b.label, undefined, { numeric: true });
          });

          setSessionOptions(sessions);
          setClassOptions(classes);
        }
      } catch (error) {
        console.error("Error fetching session/class data:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching session/class data: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };

    fetchSessionsAndClasses();
  }, []);

  const searchFaculty = async (searchKey) => {
    if (searchKey.length < 3) {
      return;
    }

    try {
      const token = localStorage.getItem("other");
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-faculty-list/?search_key=${searchKey}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data) {
        setFacultyList(data);
      }
    } catch (error) {
      console.error("Error searching faculty:", error);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Error searching faculty: {error.message}</span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    }
  };

  const handleQuestionPaperDetails = (details) => {
    setSelectedQuesPaper({
      id: details.ques_paper_id,
      label: details.ques_paper_name,
    });
  };

  const QUESTIONPaperName = selectedQuesPaper?.label || "";

  useEffect(() => {
    if (!userName || !clientBranchId) return;

    const fetchTestTemplates = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-test-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTestTemplates(data);
      } catch (error) {
        console.error("Error fetching test templates:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching test templates: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  useEffect(() => {
    setSelectedMarkingSchemes(Array(markingSchemeCount).fill(null));
  }, [markingSchemeCount]);

  const handleTestSeriesSelect = (selectedId) => {
    setSelectedTestSeries(selectedId);

    if (selectedId === 0) {
      setTestSeriesDescription("");
      setCourseOpted("");
      setSelectedScope(null);
      setTestSeriesPrefix("");
      setSelectedClass(null);
      setTestSeriesDescription("");
      setTime("");
      setTimeMinutes("");
      setFormData((prev) => ({
        ...prev,
        scope_ref_id: [],
      }));
      return;
    }

    const selectedSeries = testSeries.find((ts) => ts.ts_id === selectedId);

    if (selectedSeries) {
      setTestSeriesDescription(selectedSeries.ts_desc || "");
      setCourseOpted({
        id: selectedSeries.course_id,
        label: selectedSeries.course_name,
      });
      setSelectedScope({
        id: selectedSeries.scope_id,
        label: selectedSeries.scope_name,
      });

      setTestSeriesPrefix("");

      if (selectedSeries.duration_mins) {
        setTimeMinutes(selectedSeries.duration_mins);
        setTime((selectedSeries.duration_mins / 60).toFixed(2));
      } else {
        setTime("");
        setTimeMinutes("");
      }

      if (
        selectedSeries.class_id_list &&
        Array.isArray(selectedSeries.class_id_list)
      ) {
        const parsedClasses = selectedSeries.class_id_list.map((id) => {
          const match = classOptions.find((cls) => cls.id === id);
          return match || { label: `Class ${id}`, id };
        });
        setSelectedClass(parsedClasses.map((cls) => cls.id));
      }

      const scopeRefIds = selectedSeries.scope_ref_ids || [];
      setFormData((prev) => ({
        ...prev,
        scope_ref_id: scopeRefIds,
      }));

      if (
        selectedSeries.scope_ref_ids &&
        Array.isArray(selectedSeries.scope_ref_ids)
      ) {
        const scopeNames = selectedSeries.scope_ref_ids
          .map((item) => item.name)
          .join(", ");
        setScopeRefDisplay(scopeNames);
      }

      const scopeId = selectedSeries.scope_id;
      setTimeout(() => {
        switch (scopeId) {
          case 1:
            setSelectedBatch(scopeRefIds);
            break;
          case 2:
            setSelectedBranch(scopeRefIds);
            break;
          case 3:
            setSelectedZone(scopeRefIds);
            break;
          case 4:
            setSelectedCities(scopeRefIds);
            break;
          case 5:
            setSelectedStates(scopeRefIds);
            break;
          case 6:
            setSelectedRegion(scopeRefIds);
            break;
          default:
            break;
        }
      }, 500);

      const scheduleData = selectedSeries;
      const msFromSchedule = selectedSeries.marking_scheme || [];

      if (paperSubjects?.length && Array.isArray(msFromSchedule)) {
        const newSelections = {};

        paperSubjects.forEach((subject) => {
          const match = msFromSchedule.find(
            (ms) => ms.subject_id === subject.subject_id
          );
          if (!match) return;

          subject.sections.forEach((section, idx) => {
            const char = String.fromCharCode(97 + idx);
            const msId = match[`ms_id_sec_${char}`];
            if (msId) {
              const rowKey = `${subject.subject_name}-${section.section_no}`;
              newSelections[rowKey] = msId;
            }
          });
        });

        setSelectedMarkingSchemes((prev) => ({ ...prev, ...newSelections }));
      }
    }
  };

  const isCancelled = searchParams.get("isCancelled") === "true";

  const handleSave = async () => {
    // ── Validate start date ───────────────────────────────────────────────────
    // Only enforce 15-min-from-now if the start date was changed from saved value
    const startWasEdited = testStartDate !== savedStartDateRef.current;
    if (startWasEdited) {
      const minAllowed = getCurrentDateTime(); // server time + 15 min
      if (testStartDate && testStartDate < minAllowed) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Test window start must be at least 15 minutes from current time.
                Please correct the start time before saving.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
      const savedStart = savedStartDateRef.current;
      if (savedStart && testStartDate < savedStart) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Test window start can only be moved to a later time than the
                last saved value.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    // ── Validate end date ─────────────────────────────────────────────────────
    const endWasEdited = testEndDate !== savedEndDateRef.current;
    if (endWasEdited) {
      const savedEnd = savedEndDateRef.current;
      if (savedEnd && testEndDate < savedEnd) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Test window end can only be extended beyond the last saved
                value, not reduced.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    // ── End must be after start ───────────────────────────────────────────────
    if (testStartDate && testEndDate && testEndDate <= testStartDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Test window end must be after the test window start.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    // ── End must accommodate full duration ────────────────────────────────────
    if (testStartDate && testEndDate && timeMinutes) {
      const start = new Date(testStartDate);
      const end = new Date(testEndDate);
      const minutesDiff = (end - start) / (1000 * 60);
      const requiredMinutes = parseInt(timeMinutes, 10);
      if (minutesDiff < requiredMinutes) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Test window duration must be at least {requiredMinutes} minutes
                ({(requiredMinutes / 60).toFixed(2)} hours). Please adjust your
                test window.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    const scopeSelectionFilled = Array.isArray(scopeSelection)
      ? scopeSelection.length > 0
      : !!scopeSelection;
    const studentGroupFilled = Array.isArray(selectedStudentGroup)
      ? selectedStudentGroup.length > 0
      : !!selectedStudentGroup;

    if (isScopeGroup) {
      if (!studentGroupFilled) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Please select at least one Student Group when Scope is set to
                "Group".
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    } else {
      if (!scopeSelectionFilled && !studentGroupFilled) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Please select at least one Scope Reference OR a Student Group.
                Both cannot be empty.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        return;
      }
    }

    const token = localStorage.getItem("other");

    const payload = {
      ts_id: selectedTestSeries?.ts_id || selectedTestSeries || 1,
      ques_paper_scope_id: quesPaperScopeID,
      ques_paper_id: selectedQuesPaper?.id,
      test_name: testNameUserPart,
      test_desc: testDescription,
      test_window_start: testStartDate,
      test_window_end: testEndDate,
      duration_mins: Number(timeMinutes),
      no_of_sets: numberOfSets,
      test_mode: testMode,
      test_coordnator_emp_id: ChangedTestCoordinator,
      client_id: Number(clientId),
      client_branch_id: Number(clientBranchId),
      created_by: userName,
      status: 1,
      username: userName,
      instructions_html: instructionsHtml,
      scope_ref_id_list: isScopeGroup ? [] : scopeSelection,
      student_group_id_list: Array.isArray(selectedStudentGroup)
        ? selectedStudentGroup
        : selectedStudentGroup
        ? [selectedStudentGroup]
        : [],
      subjects: markingSchemeFromAPI.map((subject) => {
        const sectionKeys = ["a", "b", "c", "d"];
        const marking_scheme = {};

        sectionKeys.forEach((char, idx) => {
          const key = `${subject.subject_name}-${idx + 1}`;
          const userSelected = selectedMarkingSchemes?.[key];
          const apiValue = subject[`ms_id_sec_${char}`];

          const finalValue = userSelected ?? apiValue ?? 0;

          if (finalValue !== 0) {
            marking_scheme[`ms_id_sec_${char}`] = finalValue;
          }
        });

        return {
          subject_id: subject.subject_id,
          subject_name: subject.subject_name,
          marking_scheme: [marking_scheme],
        };
      }),
    };

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/update-test-schedule-v1/?test_schedule_id=${testScheduleId}`,
        {
          method: "PUT",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      if (result.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {result?.message || "Test schedule Updated successfully"}
                <strong> ID: {result.data}</strong>
              </span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        // Update saved refs to reflect new saved state
        savedStartDateRef.current = testStartDate;
        savedEndDateRef.current = testEndDate;
        // Lock the form back to read-only only on successful save
        setIsReadOnly(true);

        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate(-1);
        }, 1500);
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{result?.message || "Test schedule Could not Update"}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
      }
    } catch (error) {
      console.error("Save error details:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Unexpected error occurred";

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error saving test schedule: {errorMessage}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
    }
  };

  const handleGenerateCode = async () => {
    const url = `${EndPoints.PostGenerateTestCode}?test_schedule_id=${testScheduleId}&user_name=${userName}`;
    const result = await POST.withToken(
      url,
      {},
      { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
    );

    if (!result) return;

    if (result.status === 200) {
      const { test_schedule_code } = result.data;

      try {
        await navigator.clipboard.writeText(test_schedule_code);
      } catch (err) {
        console.warn("Clipboard copy failed:", err);
      }

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              {result.message}
              and Copied to Clipboard .{" "}
              <strong> Code {test_schedule_code}</strong>
            </span>
          </div>
        </div>
      );
      setActiveImg(SuccessImg);
    } else {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error: {result.message}</span>
            <span>Status: {result.status}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }

    setIsMessageBoxVisible(true);
  };

  const handleCancelTestSchedule = async (comment) => {
    const payload = {
      username: userName,
      test_schedule_id: Number(testScheduleId),
      comment: comment,
    };

    try {
      const response = await PUT.withToken(
        `${FULL_API_BASE_URL}/cancel-test-schedule/`,
        payload,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );

      if (response?.status === 200) {
        setShowCancelModal(false);

        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Test schedule cancelled successfully.</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        // Update saved refs to reflect new saved state
        savedStartDateRef.current = testStartDate;
        savedEndDateRef.current = testEndDate;
        // Lock the form back to read-only only on successful save
        setIsReadOnly(true);

        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate(-1);
        }, 1500);
      } else {
        setShowCancelModal(false);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {response?.message || "Test schedule cancelled successfully"}
              </span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate(-1);
        }, 1500);
      }
    } catch (err) {
      console.error("Cancellation error:", err);
      setMessageBox(
        <div className="Container-messageBOX">
          <img src={ErrorImg} alt="Error" />
          <span>Unexpected error: {err.message}</span>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
    }
  };

  const canChangeTestMode = () => {
    if (!CurrentTimeFromServer || !testStartDate) return false;

    const serverTime = new Date(CurrentTimeFromServer);
    const startTime = new Date(testStartDate);
    const oneHourBeforeStart = new Date(startTime.getTime() - 60 * 60 * 1000);

    return serverTime <= oneHourBeforeStart;
  };

  const isChangingToOffline = (newMode) => {
    const currentMode = testMode;
    return (currentMode === 1 || currentMode === 2) && newMode === 3;
  };

  const handleTestModeChange = (newMode) => {
    if (isChangingToOffline(newMode)) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Cannot change from Online mode to Offline mode.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    if (!canChangeTestMode()) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Test Mode can only be changed at least 1 hour before the test
              start time.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    setTestMode(newMode);
  };

  const isOfflineMode = () => testMode === 3;

  const canChangeInstructions = () => {
    if (!CurrentTimeFromServer || !testStartDate) return true;

    const serverTime = new Date(CurrentTimeFromServer);
    const startTime = new Date(testStartDate);

    return serverTime < startTime;
  };

  const showOfflineWarning = (action) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            Warning: {action} in offline mode may require manual coordination
            with test centers.
          </span>
        </div>
      </div>
    );
    setActiveImg(ErrorImg);
    setIsMessageBoxVisible(true);
  };

  const showInstructionsRestriction = () => {
    console.log("Instructions cannot be changed after the test start time.");
  };

  const handleInstructionsChange = (newValue) => {
    if (!canChangeInstructions()) {
      showInstructionsRestriction();
      return;
    }

    if (isOfflineMode()) {
      showOfflineWarning("Changing test instructions");
    }

    setInstructionsHtml(newValue);
  };

  const updateAllSectionsOfSameType = (sectionIndex, newValue) => {
    if (!markingSchemeFromAPI.length) return;

    const updatedSelections = { ...selectedMarkingSchemes };

    markingSchemeFromAPI.forEach((subjectData) => {
      const subjectName = subjectData.subject_name;
      const key = `${subjectName}-${sectionIndex + 1}`;
      updatedSelections[key] = newValue;
    });

    setSelectedMarkingSchemes(updatedSelections);
  };

  // ─── UPDATED: getMinEndDateTime uses server time ───────────────────────────
  const getMinEndDateTime = (startDateTime) => {
    if (!startDateTime) return getCurrentDateTime();

    const startDate = new Date(startDateTime);

    const durationMinutes =
      timeMinutes && parseInt(timeMinutes, 10) > 0
        ? parseInt(timeMinutes, 10)
        : 60;
    const minEndDate = new Date(
      startDate.getTime() + durationMinutes * 60 * 1000
    );

    const year = minEndDate.getFullYear();
    const month = String(minEndDate.getMonth() + 1).padStart(2, "0");
    const day = String(minEndDate.getDate()).padStart(2, "0");
    const hours = String(minEndDate.getHours()).padStart(2, "0");
    const minutes = String(minEndDate.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <>
      <div className="Leftmargin-Main-DIV test-scheduling-page">
        <div
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px",
              width: "98%",
            }}
          >
            <div
              style={{
                fontSize: "30px",
                color: `${Colors.color1}`,
                fontWeight: "400",
              }}
            >
              Test Scheduling
            </div>
            <div>
              <div className="row-cs-uni">
                {testMode === 1 && (
                  <button
                    className="create-test-section-btn"
                    style={{ marginRight: "18px", width: "160px" }}
                    onClick={handleGenerateCode}
                  >
                    GENERATE CODE
                  </button>
                )}
                <button
                  className="create-test-section-btn"
                  style={{
                    marginRight: "18px",
                    boxShadow: "0px 4px 4px 0px #00000040",
                  }}
                  onClick={() => navigate(-1)}
                >
                  CANCEL
                </button>

                {isReadOnly && !isCancelled && (
                  <button
                    className="create-test-section-btn"
                    style={{ marginRight: "18px" }}
                    onClick={() => setShowCancelModal(true)}
                  >
                    DELETE
                  </button>
                )}
                <button
                  className="create-test-section-btn"
                  style={{
                    marginRight: "18px",
                    boxShadow: "0px 4px 4px 0px #00000040",
                    cursor:
                      isCancelled || isTestWindowEnded
                        ? "not-allowed"
                        : "pointer",
                    opacity: isCancelled || isTestWindowEnded ? 0.6 : 1,
                  }}
                  onClick={
                    !isCancelled && !isTestWindowEnded
                      ? handleEditSaveClick
                      : undefined
                  }
                  disabled={isCancelled || isTestWindowEnded}
                  title={
                    isTestWindowEnded
                      ? "Cannot edit: Test window has ended"
                      : ""
                  }
                >
                  {isReadOnly ? "EDIT" : "SAVE"}
                </button>

                <button
                  className="create-test-section-btn"
                  style={{ marginRight: "0px" }}
                  onClick={() => setOpen(true)}
                >
                  DOWNLOAD
                </button>
              </div>
            </div>
          </div>
        </div>

        <PrintQuestionPaperModal
          isOpen={open}
          onClose={() => setOpen(false)}
          testScheduleId={testScheduleId}
          token={accessToken}
          fileName={testNameUserPart}
        />
        <div
          className="Header-1-C424342"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          <span>TEST INFORMATION</span>
          {bodyVisible ? (
            <img
              src={MinusImg}
              alt="Toggle"
              style={{ cursor: "pointer", width: "24px", height: "10px" }}
              onClick={toggleBodyVisible}
            />
          ) : (
            <div
              className="plus"
              style={{
                cursor: "pointer",
                fontSize: "28px",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#888",
                fontWeight: "bold",
              }}
              onClick={toggleBodyVisible}
            >
              +
            </div>
          )}
        </div>
        {bodyVisible && (
          <div className="Body-1-C424342" style={{ paddingBottom: 10 }}>
            {/* Row 1: Test Series | Description | Course */}
            <div className="row-cs-uni" style={{ alignItems: "flex-start" }}>
              <div style={{ width: "31.1%" }}>
                <ReflectDropdown
                  label="Test Series"
                  style={{ width: "100%" }}
                  setSelected={handleTestSeriesSelect}
                  selected={selectedTestSeries}
                  options={[
                    { label: "-None-", id: 0 },
                    ...testSeries.map((ts) => ({
                      label: `${ts.ts_name} / ${ts.course_name}`,
                      id: ts.ts_id,
                    })),
                  ]}
                  isRequired={false}
                  isDisabled={true}
                />
              </div>

              <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
                <InputComponent
                  label="Description"
                  style={{ width: "100%", opacity: "0.8" }}
                  value={testSeriesDescription}
                  isRequired={false}
                  disable={true}
                />
              </div>

              <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
                <DropDown3
                  label="Course"
                  style={{ width: "100%" }}
                  setSelected={setCourseOpted}
                  selected={courseOpted}
                  options={courses.map((course) => ({
                    label: course.course_name,
                    id: course.course_id,
                  }))}
                  isRequired={false}
                  disabled={true}
                />
              </div>
            </div>

            {/* Row 2: Session | Class | Scope */}
            <div className="row-cs-uni">
              <div style={{ width: "31.1%" }}>
                <DropDown
                  label="Session"
                  style={{ width: "100%" }}
                  setSelected={setSelectedSession}
                  options={sessionOptions}
                  isRequired={false}
                  disabled={true}
                />
              </div>

              <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
                <MultiSelectSearchDropdown3
                  label="Class"
                  width="100%"
                  marginLeft="0"
                  selected={selectedClass}
                  setSelected={setSelectedClass}
                  options={classOptions}
                  isRequired={false}
                  disabled={true}
                />
              </div>

              <div style={{ width: "31.1%", marginLeft: "3.2%" }}>
                <DropDown3
                  label="Scope"
                  style={{ width: "100%" }}
                  selected={selectScope}
                  setSelected={(value) => {
                    setSelectedScope(value);
                    setScopeSelection([]);
                  }}
                  options={scopes.map((scope) => ({
                    label: scope.ques_paper_scope_desc,
                    id: scope.ques_paper_scope_id,
                  }))}
                  isRequired={false}
                  disabled={isReadOnly}
                />
              </div>
            </div>

            {/* Row 3: Scope Reference | Student Group | Question Paper Name */}
            <div className="row-cs-uni">
              <div style={{ width: "31.1%", opacity: isReadOnly ? 0.8 : 1 }}>
                {isReadOnly ? (
                  <InputComponent
                    label="Scope Reference"
                    style={{ width: "100%" }}
                    value={isScopeGroup ? "N/A (Group scope)" : scopeRefNAMES}
                    isRequired={false}
                    disable={true}
                  />
                ) : (
                  <MultiSelectSearchDropdown
                    label="Scope Reference"
                    width="100%"
                    marginLeft="0"
                    selected={scopeSelection}
                    setSelected={setScopeSelection}
                    options={scopeSpecificData}
                    isRequired={!isScopeGroup}
                    placeholder={
                      isScopeGroup
                        ? "Disabled for Group scope"
                        : `Select ${getScopeLabel(selectScope)}...`
                    }
                    singleSelect={false}
                    disabled={isScopeGroup}
                  />
                )}
              </div>

              <div
                style={{
                  width: "31.1%",
                  marginLeft: "3.2%",
                  opacity: isReadOnly ? 0.8 : 1,
                }}
              >
                {isReadOnly ? (
                  <InputComponent
                    label="Student Group"
                    style={{ width: "100%" }}
                    value={studentGroupNames || "None"}
                    isRequired={false}
                    disable={true}
                  />
                ) : (
                  <>
                    <MultiSelectSearchDropdown
                      label={
                        studentGroupsLoading ? (
                          <>
                            Student Group{" "}
                            <span
                              style={{
                                fontSize: 12,
                                color: "#666",
                                marginLeft: 6,
                              }}
                            >
                              loading...
                            </span>
                          </>
                        ) : (
                          "Student Group"
                        )
                      }
                      width="100%"
                      marginLeft="0"
                      selected={selectedStudentGroup}
                      setSelected={(val) => {
                        setSelectedStudentGroup(val);
                        if (Array.isArray(val) && val.length > 0) {
                          const matchingGroups = allStudentGroups.filter((g) =>
                            val.includes(g.id)
                          );
                          setStudentGroupNames(
                            matchingGroups.map((g) => g.label).join(", ")
                          );
                        } else {
                          setStudentGroupNames("");
                        }
                      }}
                      options={getFilteredStudentGroups().map((g) => ({
                        label: g.label,
                        id: g.id,
                      }))}
                      isRequired={isScopeGroup}
                      placeholder="Select Student Group..."
                      singleSelect={false}
                      onSearchInputChange={searchStudentGroups}
                      disabled={false}
                    />
                    {studentGroupsError && (
                      <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                        {studentGroupsError}
                      </div>
                    )}
                  </>
                )}
              </div>

              <div
                style={{
                  width: "31.1%",
                  marginLeft: "3.2%",
                  opacity: isReadOnly ? 0.8 : 1,
                }}
              >
                <InputComponent
                  label="Question Paper Name"
                  style={{ width: "100%" }}
                  value={QUESTIONPaperName}
                  isRequired={false}
                  disable={true}
                />
              </div>
            </div>

            {/* Row 4: Question Paper Description | Subjects | Question Paper Created By */}
            <div className="row-cs-uni">
              <div style={{ width: "31.1%", opacity: isReadOnly ? 0.8 : 1 }}>
                <InputComponent
                  label="Question Paper Description"
                  style={{ width: "100%" }}
                  value={quesPaperDescription}
                  isRequired={false}
                  disable={true}
                />
              </div>

              <div
                style={{
                  width: "31.1%",
                  marginLeft: "3.2%",
                  opacity: isReadOnly ? 0.8 : 1,
                }}
              >
                <InputComponent
                  label="Subjects"
                  style={{ width: "100%" }}
                  value={testSeriesSubjects}
                  isRequired={false}
                  disable={true}
                  icon={introgativeImgBlue}
                />
              </div>

              <div
                style={{
                  width: "31.1%",
                  marginLeft: "3.2%",
                  opacity: isReadOnly ? 0.8 : 1,
                }}
              >
                <InputComponent
                  label="Question Paper Created By"
                  style={{ width: "100%" }}
                  value={quesPaperCreatedBy}
                  isRequired={false}
                  disable={true}
                />
              </div>
            </div>
          </div>
        )}

        <div
          className="Header-1-C424342"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "20px",
          }}
        >
          <span>TEST SCHEDULING</span>
          {schedulingVisible ? (
            <img
              src={MinusImg}
              alt="Toggle"
              style={{ cursor: "pointer", width: "24px", height: "10px" }}
              onClick={toggleSchedulingVisible}
            />
          ) : (
            <div
              className="plus"
              style={{
                cursor: "pointer",
                fontSize: "28px",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#888",
                fontWeight: "bold",
              }}
              onClick={toggleSchedulingVisible}
            >
              +
            </div>
          )}
        </div>
        {schedulingVisible && (
          <div
            style={{
              position: "relative",
              opacity: isReadOnly ? 0.6 : 1,
              pointerEvents: isReadOnly ? "none" : "auto",
            }}
          >
            <div className="Body-1-C424342">
              <div className="row-cs-uni">
                <div className="col-cs3-5">
                  <label
                    style={{
                      color: "#6A6A6A",
                      marginBottom: "6px",
                      display: "block",
                    }}
                  >
                    Test Name
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #a4a4a4",
                    }}
                  >
                    {testSeriesPrefix && (
                      <span
                        style={{
                          color: `${Colors.color3}`,
                          marginRight: "5px",
                        }}
                      >
                        {testSeriesPrefix}
                      </span>
                    )}
                    <input
                      type="text"
                      value={testNameUserPart}
                      onChange={(e) => setTestNameUserPart(e.target.value)}
                      placeholder="Enter test name"
                      style={{
                        flex: 1,
                        border: "none",
                        outline: "none",
                        fontSize: "inherit",
                        color: `${Colors.color3}`,
                        height: "28px",
                        paddingLeft: "5px",
                      }}
                    />
                  </div>
                </div>
                <div className="col-cs">
                  <div style={{ marginLeft: "3.6%", marginTop: "2px" }}>
                    <label
                      style={{
                        color: `${Colors.color3}`,
                        marginBottom: "4px",
                        display: "block",
                      }}
                    >
                      Description
                    </label>
                    <input
                      className="date-CB2"
                      id="description"
                      name="description"
                      placeholder="Enter description"
                      value={testDescription}
                      onChange={(e) => setTestDescription(e.target.value)}
                      style={{
                        width: "99.8%",
                        padding: "5px",
                        color: `${Colors.color3}`,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row-cs-uni" style={{ marginTop: "7px" }}>
                <div className="col-cs-uni">
                  <div style={{ marginBottom: "5px" }}>
                    <label style={{ color: `${Colors.color3}` }}>
                      Test Window Start
                    </label>
                    {/* ─── UPDATED: min attr enforces server time + 15 min in the picker ── */}
                    <input
                      className="date-CB2-3"
                      type="datetime-local"
                      id="testWindowStart"
                      name="testWindowStart"
                      value={testStartDate}
                      min={getCurrentDateTime()}
                      onChange={(e) => {
                        setTestStartDate(e.target.value);
                      }}
                      style={{ color: `${Colors.color3}` }}
                    />
                  </div>

                  <InputComponent
                    label="Test Coordinator"
                    style={{
                      width: "93.3%",
                      opacity: "0.8",
                    }}
                    value={testCoordinator}
                    isRequired={false}
                    disable={true}
                  />

                  <div style={{ marginTop: "8px" }}>
                    <DropDown2
                      label="Shuffle Subjects"
                      style={{ width: "93.3%" }}
                      selected={shuffleSubjects}
                      setSelected={(newValue) => {
                        if (isOfflineMode() && newValue !== shuffleSubjects) {
                          showOfflineWarning(
                            "Changing shuffle subjects setting"
                          );
                        }
                        setShuffleSubjects(newValue);
                      }}
                      options={[
                        { id: 1, label: "Yes" },
                        { id: 0, label: "No" },
                      ]}
                      isRequired={false}
                      disabled={numberOfSets < 2}
                    />
                  </div>
                </div>
                <div className="col-cs-uni">
                  <div
                    style={{
                      marginBottom: "4px",
                      marginLeft: "3.2%",
                      marginRight: "3px",
                    }}
                  >
                    <label style={{ color: "GrayText" }}>
                      Test Window End{" "}
                      <span style={{ color: `${Colors.color15}` }}>*</span>
                    </label>
                    <input
                      className="date-CB3"
                      type="datetime-local"
                      id="testWindowEnd"
                      name="testWindowEnd"
                      min={
                        testStartDate
                          ? getMinEndDateTime(testStartDate)
                          : getCurrentDateTime()
                      }
                      value={testEndDate}
                      onChange={(e) => {
                        setTestEndDate(e.target.value);
                      }}
                      style={{ color: `${Colors.color3}` }}
                    />
                  </div>

                  <ReflectDropdown
                    label="Test Mode"
                    style={{ width: "93.1%", marginLeft: "3.2%" }}
                    setSelected={handleTestModeChange}
                    selected={testMode}
                    options={[
                      { id: 1, label: "Online (with test code)" },
                      { id: 2, label: "Online (without test code)" },
                      { id: 3, label: "Offline" },
                    ]}
                    isRequired={false}
                    isDisabled={isReadOnly || !canChangeTestMode()}
                  />

                  <DropDown2
                    label="Shuffle Questions"
                    style={{
                      width: "93.1%",
                      marginLeft: "3.2%",
                      marginTop: "8px",
                    }}
                    selected={shuffleQuestions}
                    setSelected={setShuffleQuestions}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={numberOfSets < 2}
                  />
                </div>
                <div className="col-cs-uni">
                  <div style={{ width: "98.1%", marginLeft: "1.9%" }}>
                    <label
                      style={{
                        marginBottom: "6px",
                        display: "block",
                        color: "GrayText",
                      }}
                    >
                      Duration
                    </label>
                    <div style={{ position: "relative", width: "100%" }}>
                      <input
                        placeholder="( In minutes )"
                        type="number"
                        className="time-input2"
                        value={timeMinutes}
                        onChange={handleInputChange}
                        style={{ width: "100%", paddingRight: "50px" }}
                      />
                      <div
                        className="time-display"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "35%",
                          transform: "translateY(-50%)",
                          color: `${Colors.color2}`,
                        }}
                      >
                        {time} hr
                      </div>
                    </div>
                  </div>

                  <DropDown2
                    label="Number of Sets"
                    style={{ width: "98.1%", marginLeft: "1.9%" }}
                    selected={numberOfSets}
                    setSelected={(newValue) => {
                      if (isOfflineMode() && newValue !== numberOfSets) {
                        showOfflineWarning("Changing number of sets");
                      }
                      setNumberOfSets(newValue);
                    }}
                    options={[
                      { id: 1, label: "1" },
                      { id: 2, label: "2" },
                      { id: 3, label: "3" },
                      { id: 4, label: "4" },
                      { id: 5, label: "5" },
                      { id: 6, label: "6" },
                    ]}
                    isRequired={false}
                    disabled={isReadOnly}
                  />

                  <DropDown2
                    label="Shuffle Options"
                    style={{
                      width: "98.1%",
                      marginLeft: "1.9%",
                      marginTop: "10px",
                    }}
                    selected={shuffleOptions}
                    setSelected={setShuffleOptions}
                    options={[
                      { id: 1, label: "Yes" },
                      { id: 0, label: "No" },
                    ]}
                    isRequired={false}
                    disabled={true}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  marginBottom: "20px",
                  opacity: !canChangeInstructions() ? 0.6 : 1,
                  pointerEvents: !canChangeInstructions() ? "none" : "auto",
                }}
              >
                <TextEditor
                  templates={testTemplates}
                  value={instructionsHtml}
                  setValue={handleInstructionsChange}
                  disabled={!canChangeInstructions()}
                />
              </div>
            </div>

            {isReadOnly && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 10,
                }}
              />
            )}
          </div>
        )}

        <div style={{ marginBottom: "100px" }}>
          <div
            className="Header-1-C424342"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: "5px",
              paddingBottom: "5px",
              paddingLeft: "20px",
              paddingRight: "20px",
              marginTop: "20px",
            }}
          >
            <span>MARKING SCHEME </span>
            {markingSchemeVisible ? (
              <img
                src={MinusImg}
                alt="Toggle"
                style={{ cursor: "pointer", width: "24px", height: "10px" }}
                onClick={toggleMarkingSchemeVisible}
              />
            ) : (
              <div
                className="plus"
                style={{
                  cursor: "pointer",
                  fontSize: "28px",
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: `${Colors.color3}`,
                  fontWeight: "bold",
                }}
                onClick={toggleMarkingSchemeVisible}
              >
                +
              </div>
            )}
          </div>
          {markingSchemeVisible && (
            <div
              className="Body-1-C424342"
              style={{
                padding: "15px",
                color: `${Colors.color1}`,
                marginBottom: "100px",
              }}
            >
              {markingSchemeFromAPI.map((subjectData) => {
                const subjectName = subjectData.subject_name;

                const sectionKeys = Object.keys(subjectData).filter((key) =>
                  key.startsWith("ms_id_sec_")
                );

                return sectionKeys.map((key, index) => {
                  const sectionLabel = `Section ${String.fromCharCode(
                    65 + index
                  )}`;
                  const selectedId = subjectData[key];
                  const scheme = markingSchemeList.find(
                    (ms) => ms.ms_id === selectedId
                  );

                  return (
                    <div
                      className="row-cs"
                      key={`${subjectName}-${sectionLabel}`}
                      style={{ marginBottom: "12px", fontSize: "14px" }}
                    >
                      <div
                        className="col-cs"
                        style={{
                          paddingRight: "10px",
                          opacity: !isReadOnly ? 1 : 0.9,
                          color: !isReadOnly ? Colors.color1 : Colors.color11,
                        }}
                      >
                        <div style={{ marginTop: "10px" }}>
                          {subjectName} - {sectionLabel}
                        </div>
                      </div>

                      <div
                        className="col-cs"
                        style={{
                          paddingRight: "10px",
                          marginTop: "0px !important",
                        }}
                      >
                        <ReflectDropdown
                          style={{ width: "100%", marginLeft: "1%" }}
                          options={markingSchemeList.map((ms) => ({
                            label: ms.ms_name,
                            id: ms.ms_id,
                          }))}
                          selected={
                            selectedMarkingSchemes?.[
                              `${subjectName}-${index + 1}`
                            ] ?? selectedId
                          }
                          setSelected={(val) => {
                            if (!isReadOnly) {
                              updateAllSectionsOfSameType(index, val);
                            }
                          }}
                          isDisabled={isReadOnly}
                        />
                      </div>

                      <div className="col-cs">
                        <div
                          style={{
                            marginBottom: "4px",
                            color: `${Colors.color1}`,
                            marginLeft: "3%",
                            marginTop: "13px",
                            opacity: !isReadOnly ? 1 : 0.9,
                            color: !isReadOnly ? Colors.color1 : Colors.color11,
                          }}
                        >
                          {scheme
                            ? `${scheme.expression} ; ${scheme.ms_desc}`
                            : "—"}
                        </div>
                      </div>
                    </div>
                  );
                });
              })}
            </div>
          )}
        </div>
      </div>

      <RejectModal
        isOpen={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onSubmit={handleCancelTestSchedule}
        title="Cancel Test Schedule"
        placeholder="Enter reason for cancelling the test schedule..."
        setMessageBox={setMessageBox}
        setIsMessageBoxVisible={setIsMessageBoxVisible}
        setActiveImg={setActiveImg}
        errorImg={ErrorImg}
      />

      <TestPrintModal
        isOpen={showPrintModal}
        onClose={() => setShowPrintModal(false)}
        testScheduleId={testScheduleId}
        selectedSet={selectedPrintSet}
      />
    </>
  );
};

export default TestSchedulingClone;
